"use client";
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import SplashText from "../SplashText";
import SubMenuPage from "./SubMenuPage";
import MenuCatalouges from "./MenuCatalouges";
import { format, toZonedTime } from "date-fns-tz";
import { parse } from "date-fns";
import UseToast from "../../../UseToast";
import TrivaMainTopics from "../../TriviaQuiz/TrivaMainTopics";
import { clearAllVideos } from "../../../../utils/videoDB";
import CircularDownloadProgress from "../../../../utils/CircularDownloadProgress";
import SplashVideoPlayer from "./SplashVideoPlayer";
import AirtableMenu from "./AirtableMenu";
import AirtableVideoPlayer from "./AirtableVideoPlayer";
import VideoPlayerMenu from "./VideoPlayerMenu";
import SplashClosedVideoLoop from "./SplashClosedVideoLoop";

import CCToggle from "../../../CCToggle";

// Import Wayfinder components
import WayfinderSearchScreenFixed from "../../../Wayfinder/WayfinderSearchScreenFixed";
import AvatarScreen from "../../../Wayfinder/AvatarScreen";
import { sortAndAssignSides } from "../../../../utils/orderingUtils";
import WeatherWidget from "../../../WeatherWidget";

// Import memory monitor for debugging (can be removed in production)
import memoryMonitor from "../../../../utils/memoryMonitor";

export default function FrontendView() {
  const { client_url } = useParams();
  
  // Component mounted ref to prevent state updates after unmount
  const isMountedRef = useRef(true);
  
  // Safe state setter helper
  const safeSetState = (setter, value) => {
    if (isMountedRef.current) {
      setter(value);
    }
  };
  
  const [splashText, setSplashText] = useState("");
  const [menusplashText, setMenuSplashText] = useState("");
  const [selectedMainMenuSplashText, setSelectedMainMenuSplashText] =
    useState("");
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [primaryMenu, setPrimaryMenu] = useState([]);
  const [primarySubMenu, setPrimarySubMenu] = useState([]);
  const [screenSteps, setScreenSteps] = useState(0);
  const [parentMenuId, setParentMenuId] = useState(null);
  const [prevParentMenuId, setPrevParentMenuId] = useState(null);
  const [clickedLinkedId, setClickedLinkedId] = useState(null);
  const [prevClickedLinkedId, setPrevClickedLinkedId] = useState(null);
  const [menuBackButton, setMenuBackButton] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [videotime, setVideoTime] = useState(0);
  const [selectedMainMenuVideoTime, setSelectedMainMenuVideoTime] = useState(0);
  const [splashVideoTime, setSplashVideoTime] = useState(0);
  const [frontendMainMenu, setFrontendMainMenu] = useState([]);
  const [menuContent, setMenuContent] = useState("video");
  const [externalweblink, setExternalweblink] = useState("");
  const [isTimeRange, setIsTimeRange] = useState(true);
  const isTimeRangeRef = useRef(null);
  const [heightoffset, setHeightOffset] = useState(0);
  const [leftoffsetsplash, setLeftOffSetSplash] = useState(0);
  const [userBtnSession, setUserBtnSession] = useState([]);
  const [isSecondView, setIsSecondView] = useState(0);
  const hasUpdated = useRef(false);
  const [brandColor, setBrandColor] = useState("");
  const [triviaQuiz, setTriviaQuiz] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [triviaQuizTopics, setTriviaQuizTopics] = useState([]);
  const [triviaQuizSettings, setTriviaQuizSettings] = useState({});
  const [clickedTopic, setClickedTopic] = useState(false);
  const { showErrorToast, dismissToast } = UseToast();
  const [questions, setQuestions] = useState([]);
  const [brandFont, setBrandFont] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [splashTextDownload, setSplashTextDownload] = useState("");
  const [videoDownloaded, setVideoDownloaded] = useState(false);
  const [selectedTopicId, setSelectedTopicId] = useState(null);
  const hasFetchedMediaRef = useRef(false);
  const [userSteps, setUserSteps] = useState(0);
  const [userStepsArr, setUserStepsArr] = useState([]);
  const numColumns = useRef(null);
  const enableOffset = useRef(null);
  const columnSpacing = useRef(null);
  const disableAnimation = useRef(null);
  const leftOffset = useRef(null);
  const rightOffset = useRef(null);
  const topOffset = useRef(null);
  const isSubMenuSecondView = useRef(null);
  const isSubMenuThirdView = useRef(null);
  const [currentMenuId, setCurrentMenuId] = useState(null);
  
  // AbortController for cancelling requests
  const abortControllerRef = useRef(null);

  const enableVideoEndOffset = useRef(null);
  const videoEndLeftOffset = useRef(null);
  const videoEndRightOffset = useRef(null);
  const videoEndTopOffset = useRef(null);

  // Next Navigation Button refs
  const enableNextNavigation = useRef(false);
  const nextButtonTopOffset = useRef(null);
  const nextButtonLeftOffset = useRef(null);
  const nextButtonRightOffset = useRef(null);
  const nextButtonBottomOffset = useRef(null);

  const enableVideoEndNavigation = useRef(false);
  const videoEndNavigationMenuId = useRef(null);

  // Wheelchair content offset ref
  const wheelchairContentOffsetY = useRef(20);

  // Store Next Navigation settings for the current submenu parent (global for all content pages in that submenu)
  const subMenuNextNavSettings = useRef({
    enableNextNavigation: false,
    nextButtonTopOffset: null,
    nextButtonLeftOffset: null,
    nextButtonRightOffset: null,
    nextButtonBottomOffset: null,
  });

  // Track current content page index for next navigation
  const [currentSubMenuContentIndex, setCurrentSubMenuContentIndex] =
    useState(-1);
  const [currentMainMenuContentIndex, setCurrentMainMenuContentIndex] =
    useState(-1);

  // Track the current parent menu ID for submenu navigation
  const currentSubMenuParentRef = useRef(null);

  // Helper function to check if a button is a content page
  const isContentPage = (button) => {
    // 1️⃣ Must not have wayfinder
    const hasNoWayfinder = !button.linkedWayfinder?.status;

    // 2️⃣ Must not have trivia
    const hasNoTrivia = !button.linkedTrivia;

    // 3️⃣ Button must NOT have children
    const hasChildren = primarySubMenu.some(
      (item) => item.parentId === button.id,
    );

    const isNotMenuLink = !hasChildren;

    // 4️⃣ linkbtnId must NOT point to menu having children
    const linkDoesNotHaveChildren = button.linkbtnId
      ? !primarySubMenu.some((item) => item.parentId === button.linkbtnId)
      : true;

    // 5️⃣ Button itself must NOT be main menu linked
    const isNotMainMenuLinked = !button.mainMeuLinked;

    return (
      hasNoWayfinder &&
      hasNoTrivia &&
      isNotMenuLink &&
      linkDoesNotHaveChildren &&
      isNotMainMenuLinked
    );
  };

  // Airtable Integration States
  const [isAirtableEnabled, setIsAirtableEnabled] = useState(false);
  const [airtableConfig, setAirtableConfig] = useState(null);
  const [airtableVideoData, setAirtableVideoData] = useState(null);
  const [airtableData, setAirtableData] = useState([]);
  const [airtableVideoList, setAirtableVideoList] = useState([]);
  const [airtableVideosDownloaded, setAirtableVideosDownloaded] =
    useState(false);
  const [skipAttractLoop, setSkipAttractLoop] = useState(false);
  const [preventPreloadScreen, setPreventPreloadScreen] = useState(false);
  const [removeWhiteFlashOnVideo, setRemoveWhiteFlashOnVideo] = useState(false);
  const [menuPopup, setMenuPopup] = useState(false);
  const [redirectAttactLoop, setRedirectAttactLoop] = useState(false);
  const [userId, setUserId] = useState("");
  const [popupDisable, setPopupDisable] = useState(false);
  const [disableLocalVideoDownload, setDisableLocalVideoDownload] = useState(false);

  const popupDisableRef = useRef(false);

  // Wayfinder state variables
  const [showWayfinderSearch, setShowWayfinderSearch] = useState(false);
  const [showWayfinderCategory, setShowWayfinderCategory] = useState(false); // New state for category screen
  const [showWayfinderAvatar, setShowWayfinderAvatar] = useState(false);
  const [wayfinderSearchData, setWayfinderSearchData] = useState([]);
  const [wayfinderLocationData, setWayfinderLocationData] = useState(null);
  const [wayfinderNavigationHistory, setWayfinderNavigationHistory] = useState(
    [],
  );
  const [wayfinderSearchSettings, setWayfinderSearchSettings] = useState(null);
  const [wayfinderBackButton, setWayfinderBackButton] = useState(null);
  const [wayfinderQRCodeSettings, setWayfinderQRCodeSettings] = useState(null);
  const [wayfinderQRCodeConfig, setWayfinderQrCodeConfig] = useState(null);
  const [wayfinderMapPositionSettings, setWayfinderMapPositionSettings] =
    useState(null);
  const [wayfinderReplayPopupSettings, setWayfinderReplayPopupSettings] = useState(null);

  // Store current linkedWayfinder configuration for filtering
  const [currentWayfinderConfig, setCurrentWayfinderConfig] = useState(null);

  // Store current button ID for wayfinder
  const [currentWayfinderButtonId, setCurrentWayfinderButtonId] = useState(null);

  // Track where wayfinder was opened from (for proper back navigation)
  const [wayfinderEntryPoint, setWayfinderEntryPoint] = useState(null); // 'mainMenu' or 'subMenu'
  const [wayfinderPreviousScreen, setWayfinderPreviousScreen] = useState(null); // Store previous screenSteps value
  const [wayfinderMode, setWayfinderMode] = useState(null); // Store the mode: 'directLocation', 'categories', 'searchPage'

  // Main SubCategory Settings for Wayfinder
  const [
    wayfinderMainSubCategorySettings,
    setWayfinderMainSubCategorySettings,
  ] = useState(null);
  const [wayfinderSubCategoryHeader, setWayfinderSubCategoryHeader] = useState({
    enabled: true,
    text: "Select a SubCategory",
    fontSize: 32,
    fontWeight: 600,
    color: "#000000",
    textAlign: "center",
    marginTop: 40,
    marginBottom: 20,
    opacity: 1,
    textShadowH: 2,
    textShadowV: 2,
    textShadowBlur: 4,
    textShadowColor: "#00000033",
    top: 10,
    left: 10,
  });
  const [wayfinderSubCategoryDescription, setWayfinderSubCategoryDescription] =
    useState({
      enabled: false,
      text: "",
    });
  const [wayfinderSubCategoryFooter, setWayfinderSubCategoryFooter] = useState({
    enabled: false,
    text: "",
  });
  const [
    wayfinderSubCategoryUploadedUrls,
    setWayfinderSubCategoryUploadedUrls,
  ] = useState({
    upperLeft: { enabled: false, fileUrl: "", width: 100 },
    upperRight: { enabled: false, fileUrl: "", width: 100 },
    bottomLeft: { enabled: false, fileUrl: "", width: 100 },
    bottomRight: { enabled: false, fileUrl: "", width: 100 },
  });

  const [showWayfinderSubCategory, setShowWayfinderSubCategory] =
    useState(false);


  const isNavigatingBackRef = useRef(false);


  const [logoBeforeMap, setLogoBeforeMap] = useState({})

  ////////////////////////////////////////////////

  const getToggleStateKey = () =>
    `invisibleToggleState_${client_url || "default"}`;

  const [toggleState, setToggleState] = useState(() => {
    try {
      const stored = localStorage.getItem(getToggleStateKey());
      return stored === "true"; // Convert string to boolean
    } catch (error) {
      console.error("Error reading toggle state from localStorage:", error);
      return false;
    }
  });

  // Update splash video enabled flags based on toggleState from localStorage
  useEffect(() => {
    if (client_url) {
      const splashVideoKey = `splashVideoEnabled_${client_url}`;
      const splashVideoTwoKey = `splashVideoTwoEnabled_${client_url}`;

      const video1Enabled = localStorage.getItem(splashVideoKey) === "true";
      const video2Enabled = localStorage.getItem(splashVideoTwoKey) === "true";

      // Update uploadedUrls with localStorage values
      setUploadedUrls((prevUrls) => ({
        ...prevUrls,
        splashVideo: {
          ...prevUrls.splashVideo,
          enabled: video1Enabled,
        },
        splashVideoTwo: {
          ...prevUrls.splashVideoTwo,
          enabled: video2Enabled,
        },
      }));
    }
  }, [toggleState, client_url]); // Re-run when toggleState or client_url changes

  useEffect(() => {
    const toggleKey = `invisibleToggleState_${client_url || "default"}`;
    localStorage.setItem(toggleKey, false);
  }, [client_url]);

  const splashVideoRef = useRef(null);

  const toggleKey = `invisibleToggleState_${client_url || "default"}`;
  const currentState = localStorage.getItem(toggleKey) === "true";

  const handleInvisibleToggle = async () => {
    try {
      // Get current toggle state from localStorage

      const newState = !currentState;

      // Save new state to localStorage
      localStorage.setItem(toggleKey, newState.toString());
      setToggleState(newState); // Update local state immediately

      // Reset video ref to force re-render and reload of video element

      // Call backend API to toggle features
      // const response = await fetch('/api/toggle-menu-features', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({
      //     userId: client_url, // Using clientUrl as userId
      //     currentToggleState: newState,
      //   }),
      // });

      // if (response.ok) {
      //   fetchMedia(client_url);
      // } else {
      //   console.error('Toggle failed:', await response.text());
      // }
    } catch (error) {
      console.error("Error toggling features:", error);
    }
  };

  const getLanguageName = (code) => {
    const languageNames = {
      en: "English",
      es: "Español",
      fr: "Français",
      de: "Deutsch",
      it: "Italiano",
      pt: "Português",
      ru: "Русский",
      ja: "日本語",
      ko: "한국어",
      zh: "中文",
      ar: "العربية",
      hi: "हिन्दी",
      nl: "Nederlands",
      sv: "Svenska",
      da: "Dansk",
      no: "Norsk",
      fi: "Suomi",
      pl: "Polski",
      tr: "Türkçe",
      th: "ไทย",
      vi: "Tiếng Việt",
      id: "Bahasa Indonesia",
      ms: "Bahasa Melayu",
      tl: "Filipino",
      he: "עברית",
      fa: "فارسی",
      ur: "اردو",
      bn: "বাংলা",
      ta: "தமிழ்",
      te: "తెలుగు",
      ml: "മലയാളം",
      kn: "ಕನ್ನಡ",
      gu: "ગુજરાતી",
      mr: "मराठी",
      pa: "ਪੰਜਾਬੀ",
      or: "ଓଡ଼ିଆ",
      as: "অসমীয়া",
      ne: "नेपाली",
      si: "සිංහල",
      my: "မြန်မာ",
      km: "ខ្មែរ",
      lo: "ລາວ",
      ka: "ქართული",
      am: "አማርኛ",
      sw: "Kiswahili",
      zu: "isiZulu",
      af: "Afrikaans",
      sq: "Shqip",
      eu: "Euskera",
      be: "Беларуская",
      bg: "Български",
      ca: "Català",
      hr: "Hrvatski",
      cs: "Čeština",
      et: "Eesti",
      lv: "Latviešu",
      lt: "Lietuvių",
      hu: "Magyar",
      mt: "Malti",
      ro: "Română",
      sk: "Slovenčina",
      sl: "Slovenščina",
      uk: "Українська",
      cy: "Cymraeg",
      ga: "Gaeilge",
      is: "Íslenska",
      mk: "Македонски",
      sr: "Српски",
      bs: "Bosanski",
      me: "Crnogorski",
      al: "Shqip",
    };
    return languageNames[code] || code.toUpperCase();
  };

  const getLanguageFlag = (code) => {
    const flagMapping = {
      en: "us",
      es: "es",
      fr: "fr",
      de: "de",
      it: "it",
      pt: "pt",
      ru: "ru",
      ja: "jp",
      ko: "kr",
      zh: "cn",
      ar: "sa",
      hi: "in",
      nl: "nl",
      sv: "se",
      da: "dk",
      no: "no",
      fi: "fi",
      pl: "pl",
      tr: "tr",
      th: "th",
      vi: "vn",
      id: "id",
      ms: "my",
      tl: "ph",
      he: "il",
      fa: "ir",
      ur: "pk",
      bn: "bd",
      ta: "in",
      te: "in",
      ml: "in",
      kn: "in",
      gu: "in",
      mr: "in",
      pa: "in",
      or: "in",
      as: "in",
      ne: "np",
      si: "lk",
      my: "mm",
      km: "kh",
      lo: "la",
      ka: "ge",
      am: "et",
      sw: "ke",
      zu: "za",
      af: "za",
      sq: "al",
      eu: "es",
      be: "by",
      bg: "bg",
      ca: "es",
      hr: "hr",
      cs: "cz",
      et: "ee",
      lv: "lv",
      lt: "lt",
      hu: "hu",
      mt: "mt",
      ro: "ro",
      sk: "sk",
      sl: "si",
      uk: "ua",
      cy: "gb",
      ga: "ie",
      is: "is",
      mk: "mk",
      sr: "rs",
      bs: "ba",
      me: "me",
      al: "al",
    };
    return flagMapping[code] || code;
  };

  const getTextForLanguage = (
    textObj,
    fallback = "",
    language = selectedLanguage,
  ) => {
    if (!textObj) return fallback;

    // If it's already a string, return it
    if (typeof textObj === "string") return textObj;

    // If it's an object with language keys
    if (typeof textObj === "object" && textObj !== null) {
      // Try to get text for selected language
      if (textObj[language]) return textObj[language];

      // Fallback to English
      if (textObj["en"]) return textObj["en"];

      // Fallback to first available language
      const firstKey = Object.keys(textObj)[0];
      if (firstKey && textObj[firstKey]) return textObj[firstKey];
    }

    return fallback;
  };

  // Helper function to extract content from language-aware API response
  const extractContentFromResponse = (response) => {
    // Check if response has the new structure with content property
    if (response && response.content) {
      return {
        ...response.content,
        // Include shared properties from the response root
        contenttype: response.contenttype,
        externalweblink: response.externalweblink,
        videotime: response.videotime,
        menuBackButton: response.menuBackButton,
        globalSettings: response.globalSettings,
      };
    }

    // Fallback to old structure for backward compatibility
    return response;
  };

  const fetchAvailableLanguages = async (userId) => {
    try {
      // Fetch only enabled languages
      const response = await axios.get(`/api/language/enabled/${userId}`);
      if (response.data.success) {
        const languages = response.data.languages || [];
        setAvailableLanguages(languages);

        // Fetch language offsets
        try {
          const offsetsResponse = await axios.get(`/api/language/offsets/${userId}`);
          if (offsetsResponse.data.success && offsetsResponse.data.offsets) {
            setLanguageOffsets(offsetsResponse.data.offsets);
          }
        } catch (offsetError) {
          console.error("Error fetching language offsets:", offsetError);
        }

        // Fetch language customization settings
        try {
          const customizationResponse = await axios.get(`/api/language/customization/${userId}`);
          if (customizationResponse.data.success && customizationResponse.data.customization) {
            setLanguageCustomization(prev => ({
              ...prev,
              ...customizationResponse.data.customization
            }));
          }
        } catch (customizationError) {
          console.error("Error fetching language customization:", customizationError);
        }

        // Fetch language settings (for custom icons and sizes)
        try {
          const settingsResponse = await axios.get(`/api/language/settings/${userId}`);
          if (settingsResponse.data.success && settingsResponse.data.languages) {
            const icons = {};
            const sizes = {};
            const displayNames = {};
            settingsResponse.data.languages.forEach(lang => {
              if (lang.customIconUrl) {
                icons[lang.code] = lang.customIconUrl;
              }
              if (lang.customIconSize) {
                sizes[lang.code] = lang.customIconSize;
              }
              if (lang.customDisplayName) {
                displayNames[lang.code] = lang.customDisplayName;
              }
            });
            setLanguageIcons(icons);
            setLanguageIconSizes(sizes);
            setLanguageDisplayNames(displayNames);
          }
        } catch (settingsError) {
          console.error("Error fetching language settings:", settingsError);
        }

        // Check if multiple languages are available
        if (languages.length > 1) {
          // Check if user has a saved language preference
          const savedLanguage = localStorage.getItem(`language_${userId}`);
          if (savedLanguage && languages.includes(savedLanguage)) {
            setSelectedLanguage(savedLanguage);

          } else {
            // Default to English if no saved preference
            setSelectedLanguage('en');
            // Don't show language selection screen on initial load
            // User can change language using the language selector UI
          }
        } else {
          // Only one language available, use it (likely 'en')
          setSelectedLanguage(languages[0] || 'en');
        }
      }
    } catch (error) {
      console.error("Error fetching available languages:", error);
      setAvailableLanguages(["en"]);
      setSelectedLanguage("en");
    } finally {
      setLanguagesLoaded(true);
    }
  };

  const handleLanguageSelect = async (languageCode) => {
    // Save preference FIRST before setting state, so the useEffect picks up the right value
    if (currentUserId) {
      localStorage.setItem(`language_${currentUserId}`, languageCode);
    }

    setShowLanguageSelection(false);
    setIsLanguageLoading(true);
    setSelectedLanguage(languageCode);
    
    // Clear any existing timeout
    if (languageLoadingTimeoutRef.current) {
      clearTimeout(languageLoadingTimeoutRef.current);
    }
    
    // Safety timeout: Force stop loading after 10 seconds
    languageLoadingTimeoutRef.current = setTimeout(() => {
      setIsLanguageLoading(false);
      console.warn('Language loading timeout - forcing loader to stop after 10 seconds');
    }, 10000);
    
    // fetchMedia is handled by the useEffect([selectedLanguage]) below — no duplicate call needed
  };

  // Language selection states
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [showLanguageSelection, setShowLanguageSelection] = useState(false);
  const [languagesLoaded, setLanguagesLoaded] = useState(false);
  const [isLanguageLoading, setIsLanguageLoading] = useState(false);
  const [languageOffsets, setLanguageOffsets] = useState({
    left: 20,
    top: 50,
    right: null
  });
  
  // Ref to store language loading timeout
  const languageLoadingTimeoutRef = useRef(null);

  // Language box customization settings
  const [languageCustomization, setLanguageCustomization] = useState({
    outerBackgroundColor: "#808080",
    outerOpacity: 100,
    outerBorderRadius: 15,
    outerBorderWidth: 2,
    outerBorderColor: "#ffffff",
    outerPadding: 15,
    gap: 10,
    innerBackgroundColor: "#ffffff",
    innerOpacity: 20,
    innerBorderRadius: 9,
    innerBorderWidth: 2,
    innerBorderColor: "#ffffff",
    innerPadding: 15,
    fontFamily: "inherit",
    fontSize: 18,
    fontWeight: "700",
    textColor: "#ffffff",
    enableIcon: true,
    flagSize: 60,
  });

  // Store custom icons and sizes per language
  const [languageIcons, setLanguageIcons] = useState({});
  const [languageIconSizes, setLanguageIconSizes] = useState({});
  const [languageDisplayNames, setLanguageDisplayNames] = useState({});

  const [captionSettings, setCaptionSettings] = useState({
    textColor: "#ffffff",
    bgColor: "#000000",
    backgroundOpacity: 60,
    fontSize: "22",
    padding: "8",
    fontWeight: "600",
    bottom: "40",

    // Separate text shadow properties
    textShadowH: "2",
    textShadowV: "2",
    textShadowBlur: "4",
    textShadowColor: "#000000",
    lineHeight: "1.4",
    letterSpacing: "0",
    fontFamily: "Arial",
    transition: 2,
    buttonTop: 50,
    buttonLeft: 50,
    iconType: "caption",
    iconSize: 50,
    iconOnColor: "#4CAF50",
    iconOffColor: "#757575",
    status: false,
  });

  // Weather settings state
  const [weatherSettings, setWeatherSettings] = useState({ enabled: false });

  // Wheelchair settings state
  const [wheelchairSettings, setWheelchairSettings] = useState({ enabled: false });

  // Centralized wheelchair mode state (persists until session reset)
  const [isWheelchairMode, setIsWheelchairMode] = useState(() => {
    try {
      const stored = localStorage.getItem(`wheelchairMode_${client_url || 'default'}`);
      return stored === 'true';
    } catch (error) {
      console.error('Error reading wheelchair mode from localStorage:', error);
      return false;
    }
  });

  // Save wheelchair mode to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(`wheelchairMode_${client_url || 'default'}`, isWheelchairMode.toString());
      console.log(`Wheelchair mode saved to localStorage for ${client_url}:`, isWheelchairMode);
    } catch (error) {
      console.error('Error saving wheelchair mode to localStorage:', error);
    }
  }, [isWheelchairMode, client_url]);

  // Handler for wheelchair toggle
  const handleWheelchairToggle = () => {
    setIsWheelchairMode(prev => !prev);
  };

  const setLocalStorageSafe = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(`Error setting ${key}:`, error);
    }
  };

  const resetLocalStates = () => {
    const clientKey = client_url || 'default';

    // Reset states
    setIsCaptionOn(false);
    setSelectedLanguage('en');
    setIsWheelchairMode(false);

    // Reset localStorage
    setLocalStorageSafe(`captionEnabled_${clientKey}`, 'false');
    setLocalStorageSafe(`wheelchairMode_${clientKey}`, 'false');

    if (currentUserId) {
      setLocalStorageSafe(`language_${currentUserId}`, 'en');
    }

    console.log('Session reset completed');
  };

  // Centralized reset session function
  const resetWheelChairMode = () => {
    setIsWheelchairMode(false);
    try {
      localStorage.setItem(`wheelchairMode_${client_url || 'default'}`, 'false');
      console.log('Wheelchair mode reset on session reset');
    } catch (error) {
      console.error('Error resetting wheelchair mode in localStorage:', error);
    }
  }

  // Reset caption and language to defaults
  const resetCaptionAndLanguage = () => {
    // Reset caption to off
    setIsCaptionOn(false);
    try {
      localStorage.setItem(`captionEnabled_${client_url || 'default'}`, 'false');
      console.log('Caption reset to off on session reset');
    } catch (error) {
      console.error('Error resetting caption in localStorage:', error);
    }

    // Reset language to English
    setSelectedLanguage('en');
    if (currentUserId) {
      try {
        localStorage.setItem(`language_${currentUserId}`, 'en');
        console.log('Language reset to English on session reset');
      } catch (error) {
        console.error('Error resetting language in localStorage:', error);
      }
    }
  }

  // Initialize caption state from localStorage
  const [isCaptionOn, setIsCaptionOn] = useState(() => {
    try {
      const stored = localStorage.getItem(`captionEnabled_${client_url || 'default'}`);
      return stored === 'true';
    } catch (error) {
      console.error('Error reading caption state from localStorage:', error);
      return false;
    }
  });

  // Save caption state to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(`captionEnabled_${client_url || 'default'}`, isCaptionOn.toString());
      console.log(`Caption state saved to localStorage for ${client_url}:`, isCaptionOn);
    } catch (error) {
      console.error('Error saving caption state to localStorage:', error);
    }
  }, [isCaptionOn, client_url]);

  const [subMenuSettings, setSubMenuSettings] = useState({
    columnSpacing: 5,
    numColumns: "center-two-buttons-per-row",
    enableOffset: false,
    leftOffset: 5,
    topOffset: 5,
    rightOffset: 0,
    disableAnimation: false,
  });

  useEffect(() => {
    popupDisableRef.current = popupDisable;
  }, [popupDisable]);

  // Fetch available languages when userId is set
  useEffect(() => {
    if (currentUserId && !languagesLoaded) {
      fetchAvailableLanguages(currentUserId);
    }
  }, [currentUserId, languagesLoaded]);

  // Helper function to fetch location videos for preloading
  const fetchLocationVideosForPreloading = async (userId, language = "en") => {
    try {
      const response = await axios.get(
        `/api/location-videos/preload-videos/${userId}`,
        {
          params: { language },
        },
      );

      if (response.data.success && response.data.data.length > 0) {
        // Create video list entries for location videos
        const locationVideoEntries = response.data.data.map(
          (locationVideo) => ({
            url: locationVideo.url,
            key: locationVideo.key,
            type: "location_video",
            locationId: locationVideo.locationId,
            locationName: locationVideo.locationName,
          }),
        );

        // Update video list by removing old location videos and adding new ones
        setVideoList((prevVideoList) => {
          // Remove existing location videos
          const nonLocationVideos = prevVideoList.filter(
            (video) => video.type !== "location_video",
          );
          // Add new location videos
          return [...nonLocationVideos, ...locationVideoEntries];
        });

        return locationVideoEntries;
      } else {
        console.log("ℹ️ No location videos found for language:", language);

        // Remove location videos from video list if none found
        setVideoList((prevVideoList) =>
          prevVideoList.filter((video) => video.type !== "location_video"),
        );

        return [];
      }
    } catch (error) {
      console.error(
        "❌ Error fetching location videos for language change:",
        error,
      );
      return [];
    }
  };

  // Refetch menu data when language changes
  useEffect(() => {
    const handleLanguageChange = async () => {
      // If loading is true but conditions aren't met, turn it off
      if (isLanguageLoading && (!selectedLanguage || !currentUserId || !languagesLoaded)) {
        console.warn('Language change conditions not met, stopping loader');
        if (languageLoadingTimeoutRef.current) {
          clearTimeout(languageLoadingTimeoutRef.current);
        }
        setIsLanguageLoading(false);
        return;
      }

      if (selectedLanguage && currentUserId && languagesLoaded) {
        try {
          await fetchMedia(client_url);
          // Also fetch location videos for the new language
          await fetchLocationVideosForPreloading(currentUserId, selectedLanguage);
        } catch (error) {
          // Only log if not cancelled
          if (!axios.isCancel(error) && error.name !== 'CanceledError') {
            console.error("Error during language change:", error);
          }
        } finally {
          // Clear the safety timeout
          if (languageLoadingTimeoutRef.current) {
            clearTimeout(languageLoadingTimeoutRef.current);
            languageLoadingTimeoutRef.current = null;
          }
          // Always turn off loading state if component is still mounted
          if (isMountedRef.current) {
            setIsLanguageLoading(false);
          }
        }
      }
    };

    handleLanguageChange();
    
    // Cleanup timeout on unmount or dependency change
    return () => {
      if (languageLoadingTimeoutRef.current) {
        clearTimeout(languageLoadingTimeoutRef.current);
        languageLoadingTimeoutRef.current = null;
      }
    };
  }, [selectedLanguage, isLanguageLoading, currentUserId, languagesLoaded]);

  // Function to get current day in EST
  const getCurrentDayInEST = (time_zone) => {
    const timeZone = time_zone;
    const currentUtcDate = new Date();
    const zonedDate = toZonedTime(currentUtcDate, timeZone);
    return format(zonedDate, "EEEE", { timeZone });
  };

  // Function to check if current time is in the range
  const isCurrentTimeInRange = (
    startTime,
    endTime,
    time_zone = "America/New_York",
  ) => {
    const timeZone = time_zone;
    const currentUtcDate = new Date();
    const currentZonedDate = toZonedTime(currentUtcDate, timeZone);
    const startTimeInEST = parse(startTime, "HH:mm", currentZonedDate, {
      timeZone,
    });
    const endTimeInEST = parse(endTime, "HH:mm", currentZonedDate, {
      timeZone,
    });
    return (
      currentZonedDate >= startTimeInEST && currentZonedDate <= endTimeInEST
    );
  };

  // Function to filter weekly timing and check if current time is in range
  const filterCurrentDayAndCheckTime = (
    weeklyTiming,
    time_zone = "America/New_York",
  ) => {
    const currentDay = getCurrentDayInEST(time_zone);
    const currentDayTiming = weeklyTiming?.find(
      (item) => item?.day === currentDay && item?.isOpen,
    );
    if (!currentDayTiming) return null;

    const isfullDay = weeklyTiming?.find(
      (item) => item?.day === currentDay && item?.isOpen && item?.isFullDay,
    );
    if (isfullDay) return true;

    const { startTime, endTime } = currentDayTiming;
    const isInRange = isCurrentTimeInRange(startTime, endTime, time_zone);
    return isInRange;
  };

  const hasFirstTransitionHappened = useRef(false);

  const [
    enableAttractLoopSwitchOnMainMenu,
    setEnableAttractLoopSwitchOnMainMenu,
  ] = useState(false);

  const [disableAreYouTherePopup, setDisableAreYouTherePopup] = useState(false);
  const [enableInvisibleToggleButton, setEnableInvisibleToggleButton] =
    useState(false);

  useEffect(() => {
    if (!isTimeRangeRef.current && isTimeRange) {
      if (hasFirstTransitionHappened.current) {
        setScreenSteps(1);
      } else {
        hasFirstTransitionHappened.current = true;
      }
    }
    isTimeRangeRef.current = isTimeRange;
  }, [isTimeRange]);

  const [airTablesettings, setAirtableButtonSettings] = useState({
    globalSettings: {
      buttonText: "",
      cornerRadius: 5,
      height: 50,
      width: 150,
      outlineColor: "#000000",
      outlineThickness: 1,
      fillColor: "#ffffff",
      font: "Arial",
      fontColor: "#000000",
      fontSize: 16,
      shadow: {
        angle: 125,
        size: 10,
        distance: 15,
        alpha: 0.2,
        color: "#000000", // Bright orange
      },
      highlight: {
        borderColor: "#8f8f8f",
        fillColor: "#000000",
        fontColor: "#ffffff",
      },
      clickSound: "",
      clickSoundFilename: null,
      clickSoundVolume: 1,
      textAlign: "center",
      marginBottom: 2,
      lineHeight: 1,
      padding: 10,
    },
  });

  const [buttonSettings, setButtonSettings] = useState({
    backButtonSettings: {
      buttonText: "BACK",
      cornerRadius: 5,
      height: 50,
      width: 150,
      outlineColor: "#000000",
      outlineThickness: 1,
      fillColor: "#ffffff",
      font: "Arial",
      fontColor: "#000000",
      fontSize: 16,
      shadow: {
        angle: 125,
        size: 10,
        distance: 15,
        alpha: 0.2,
        color: "#000000",
      },
      highlight: {
        borderColor: "#8f8f8f",
        fillColor: "#000000",
        fontColor: "#ffffff",
      },
      clickSound: "",
      clickSoundFilename: null,
      clickSoundVolume: 1,
      textAlign: "center",
      marginBottom: 2,
      lineHeight: 1,
      padding: 10,
    },
    nextButtonSettings: {
      buttonText: "NEXT",
      cornerRadius: 5,
      height: 50,
      width: 150,
      outlineColor: "#000000",
      outlineThickness: 1,
      fillColor: "#ffffff",
      font: "Arial",
      fontColor: "#000000",
      fontSize: 16,
      shadow: {
        angle: 125,
        size: 10,
        distance: 15,
        alpha: 0.2,
        color: "#000000",
      },
      highlight: {
        borderColor: "#8f8f8f",
        fillColor: "#000000",
        fontColor: "#ffffff",
      },
      clickSound: "",
      clickSoundFilename: null,
      clickSoundVolume: 1,
      textAlign: "center",
      marginBottom: 2,
      lineHeight: 1,
      padding: 10,
    },
  });

  const [globalSettings, setGlobalSettings] = useState({
    buttonText: "",
    cornerRadius: 5,
    height: 50,
    width: 150,
    outlineColor: "#000000",
    outlineThickness: 1,
    fillColor: "#ffffff",
    font: "Arial",
    fontColor: "#000000",
    fontSize: 16,
    shadow: {
      angle: 125,
      size: 10,
      distance: 15,
      alpha: 0.2,
      color: "#000000",
    },
    highlight: {
      borderColor: "#8f8f8f",
      fillColor: "#000000",
      fontColor: "#ffffff",
    },
    clickSound: "",
    clickSoundFilename: null,
    clickSoundVolume: 1,
    textAlign: "center",
    marginBottom: 2,
    lineHeight: 1,
    padding: 10,

    // Next Navigation Button
    nextButtonFileName: "",
    nextButtonFileUrl: "",
    nextButtonWidth: 0,
    nextButtonTopOffset: 0,
    nextButtonLeftOffset: 0,
    nextButtonRightOffset: 0,
    nextButtonBottomOffset: 0,
    enableNextNavigation: false,
  });

  // State for wayfinder global sound settings
  const [wayfinderGlobalSoundSettings, setWayfinderGlobalSoundSettings] = useState({
    clickSound: "",
    clickSoundVolume: 1,
  });

  const fetchButtonSettings = async (userId) => {
    try {
      const response = await axios.get(
        `/api/airtable-button-settings/${userId}`,
      );

      if (response.data && response.data.success && response.data.data) {
        setButtonSettings(response.data.data);
      } else {
        console.log("No button settings found, using defaults");
      }
    } catch (error) {
      console.error("Error fetching button settings:", error);
      // Use default settings if fetch fails
    }
  };

  // Fetch Airtable configuration and data
  const fetchAirtableConfig = async (userId) => {
    if (!userId) return;

    if (userId) {
      fetch(`/api/get-user-global/${userId}`)
        .then((res) => res.json())
        .then((data) => {
          console.log("data", data);
          if (!data.error) {
            setAirtableButtonSettings((prevSettings) => ({
              ...prevSettings,
              globalSettings: {
                ...prevSettings?.globalSettings,
                ...data.result?.globalSettings,
              },
            }));
          }
        })
        .catch(() => console.log("Button not found, creating new settings."));
    }

    try {
      const response = await axios.get(`/api/airtable-config/${userId}`);

      if (response.data && response.data.success) {
        const { isAirtableEnabled: enabled, config } = response.data.data;
        setIsAirtableEnabled(enabled);
        setAirtableConfig(config);

        // If Airtable is enabled, fetch the data immediately
        if (enabled && config) {
          await fetchAirtableData(userId, config);
        }
      } else {
        setIsAirtableEnabled(false);
        setAirtableConfig(null);
      }
    } catch (error) {
      console.error("Error fetching Airtable config:", error);
      setIsAirtableEnabled(false);
      setAirtableConfig(null);
    }
  };

  // New function to fetch Airtable data
  const fetchAirtableData = async (userId, config) => {
    try {
      const response = await axios.post("/api/airtable-data-api", {
        userId: userId,
        config: config,
      });

      console.log("Raw Airtable API response:", response.data);

      if (response.data) {
        const records = response.data;

        console.log("Total records received:", records.length);
        console.log("Sample record:", records[0]);
        console.log("Config fields:", {
          buttonTextField1: config.buttonTextField1,
          buttonTextField2: config.buttonTextField2,
          videoLinkField: config.videoLinkField,
        });

        // More lenient filtering - only require buttonTextField1 OR videoLinkField
        const validRecords = records.filter((record) => {
          const hasButtonText =
            record.fields &&
            (record.fields[config.buttonTextField1] ||
              record.fields[config.buttonTextField2] ||
              Object.keys(record.fields).length > 0); // At least some field exists
          const hasVideo =
            record.fields && record.fields[config.videoLinkField];

          console.log("Record validation:", {
            recordId: record.id,
            hasButtonText,
            hasVideo,
            fields: Object.keys(record.fields || {}),
          });

          return hasButtonText && hasVideo;
        });

        console.log("Valid records after filtering:", validRecords.length);

        // If no valid records but we have data, show what's missing
        if (validRecords.length === 0 && records.length > 0) {
          console.error("No valid records found. Checking field mappings...");
          records.forEach((record, index) => {
            console.log(`Record ${index + 1}:`, {
              id: record.id,
              availableFields: Object.keys(record.fields || {}),
              buttonTextField1Value: record.fields?.[config.buttonTextField1],
              buttonTextField2Value: record.fields?.[config.buttonTextField2],
              videoLinkFieldValue: record.fields?.[config.videoLinkField],
            });
          });
        }

        // Sort records if sort field is specified
        const sortedRecords = [...validRecords];
        if (config.sortField) {
          sortedRecords.sort((a, b) => {
            const fieldA = a.fields[config.sortField] || 0;
            const fieldB = b.fields[config.sortField] || 0;

            if (config.sortOrder === "desc") {
              return fieldB - fieldA;
            }
            return fieldA - fieldB;
          });
        }

        // Convert to menu format with side assignment
        const processedData = sortedRecords.map((record, index) => {
          const firstName = record.fields[config.buttonTextField1] || "";
          const lastName = record.fields[config.buttonTextField2] || "";

          let buttonText;
          if (lastName && lastName.trim()) {
            buttonText = `${firstName} ${lastName}`.trim();
          } else if (firstName && firstName.trim()) {
            buttonText = firstName.trim();
          } else {
            // Fallback to first available field
            const firstField = Object.keys(record.fields)[0];
            buttonText = record.fields[firstField] || "Unnamed";
          }

          // Get video URL (handle array structure)
          let videoUrl = record.fields[config.videoLinkField];
          if (Array.isArray(videoUrl) && videoUrl.length > 0) {
            videoUrl = videoUrl[0].url;
          }

          return {
            id: record.id,
            name: buttonText,
            isVisible: true,
            videoUrl: videoUrl,
            airtableRecord: record,
            settings: airTablesettings.globalSettings,
            side: index % 2 === 0 ? "left" : "right",
            order: index,
          };
        });

        // console.log("Final processed data:", processedData)
        setAirtableData(processedData);

        // Prepare video list for preloading
        const videos = processedData.map((item) => {
          const decodedUrl = decodeURIComponent(item.videoUrl);
          const fileName = decodedUrl.split("/").pop();

          return {
            url: item.videoUrl,
            key: item.id,
          };
        });

        setAirtableVideoList(videos);
      }
    } catch (error) {
      console.error("Error fetching Airtable data:", error);
    }
  };

  const checkTime = async () => {
    try {
      const response = await fetch(`/auth/aiform/frontend/${client_url}`);
      const data = await response.json();

      if (!response.ok) {
        alert(`Error: ${data.message}`);
        return;
      }

      const aiForm = data.aiForms[0];
      const isCurrentlyInRange = filterCurrentDayAndCheckTime(
        aiForm?.weeklyTiming,
        aiForm?.timezone,
      );

      setSkipAttractLoop(aiForm?.skipAttractLoop);
      setPreventPreloadScreen(aiForm?.preventPreloadScreen);
      setRemoveWhiteFlashOnVideo(aiForm?.removeWhiteFlashOnVideo);
      setMenuPopup(aiForm?.menuPopup);
      setRedirectAttactLoop(aiForm?.redirectAttactLoop);

      setEnableAttractLoopSwitchOnMainMenu(
        aiForm?.enableAttractLoopSwitchOnMainMenu || false,
      );

      setDisableAreYouTherePopup(aiForm?.disableAreYouTherePopup || false);
      setEnableInvisibleToggleButton(
        aiForm?.enableInvisibleToggleButton || false,
      );
      setDisableLocalVideoDownload(
        aiForm?.disableLocalVideoDownload || false,
      );

      if (isCurrentlyInRange) {
        setIsTimeRange(true);
        hasFetchedMediaRef.current = false;
        return;
      }

      const timeZone = aiForm?.timezone;
      const currentUtcDate = new Date();
      const currentZonedDate = toZonedTime(currentUtcDate, timeZone);
      const currentDay = getCurrentDayInEST(timeZone);

      const currentDayTiming = aiForm?.weeklyTiming?.find(
        (item) => item?.day === currentDay && item?.isOpen,
      );

      let shouldClearVideos = true;

      if (currentDayTiming) {
        const { startTime } = currentDayTiming;
        const startTimeInEST = parse(startTime, "HH:mm", currentZonedDate, {
          timeZone,
        });

        const minutesUntilOpen =
          (startTimeInEST - currentZonedDate) / (1000 * 60);

        // if (minutesUntilOpen > 0 && minutesUntilOpen <= 30) {
        //   shouldClearVideos = false;
        //   console.log(`Opening in ${Math.round(minutesUntilOpen)} minutes`);

        //   if (!hasFetchedMediaRef.current) {
        //     fetchMedia(client_url);
        //     hasFetchedMediaRef.current = true;
        //   }
        // } else {
        //   hasFetchedMediaRef.current = false;
        // }
      }

      if (shouldClearVideos) {
        clearAllVideos();
        setIsTimeRange(false);
        setScreenSteps(0);
        setVideoList([]);
        hasFetchedMediaRef.current = false;
      }
    } catch (error) {
      console.error("Error fetching AI form data:", error);
      hasFetchedMediaRef.current = false;
    }
  };

  ////////////////----------------/////////////////////////

  const toggleSkipAttractLoop = () => {
    setPopupDisable(!popupDisable);
    // try {
    //   const response = await axios.post("/api/toggle-skip-attract-loop", {
    //     userId: currentUserId,
    //     skipAttractLoop: !skipAttractLoop,
    //   });

    //   if (response.data.success) {
    //     setSkipAttractLoop(!skipAttractLoop);
    //     console.log("Skip attract loop updated successfully");
    //   }
    // } catch (error) {
    //   console.error("Error updating skip attract loop:", error);
    // }
  };

  /////////////////////////////////////////////////////////

  // Cleanup on unmount
  useEffect(() => {
    isMountedRef.current = true;
    
    // Start memory monitoring in development
    if (process.env.NODE_ENV === 'development') {
      memoryMonitor.start(10000); // Every 10 seconds
    }
    
    return () => {
      isMountedRef.current = false;
      
      // Stop memory monitoring
      if (process.env.NODE_ENV === 'development') {
        memoryMonitor.stop();
        console.log('📊 Final Memory Report:', memoryMonitor.getReport());
      }
      
      // Cancel any pending requests
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      
      // Clear intervals
      if (loadingInterval.current) {
        clearInterval(loadingInterval.current);
      }
      
      if (languageLoadingTimeoutRef.current) {
        clearTimeout(languageLoadingTimeoutRef.current);
      }
      
      // Stop and clear video
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.src = '';
        videoRef.current.load();
      }
      
      // Clear videos from IndexedDB
      clearAllVideos();
    };
  }, []);

  useEffect(() => {
    clearAllVideos();
    checkTime();
    const interval = setInterval(checkTime, 6000);
    return () => clearInterval(interval);
  }, []);

  // Handle disableLocalVideoDownload - skip preloading screen when enabled
  useEffect(() => {
    if (disableLocalVideoDownload && screenSteps === 0 && isTimeRange) {
      console.log("Skipping video preload - disableLocalVideoDownload is enabled");
      handleInitialSteps();
    }
  }, [disableLocalVideoDownload, screenSteps, isTimeRange]);

  const [menuTextSettings, setMenuTextSettings] = useState({
    globalSettings: {
      height: 50,
      width: 150,
      font: "Arial",
      fontColor: "#127E10",
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: "#FF5733",
      },
      highlight: {
        fontColor: "#000",
      },
      textAlign: "center",
    },
  });

  const [selectedMainMenuTextSettings, setSelectedMainMenuTextSettings] =
    useState({
      globalSettings: {
        height: 50,
        width: 150,
        font: "Arial",
        fontColor: "#127E10",
        fontSize: 16,
        shadow: {
          angle: 5,
          size: 10,
          distance: 5,
          alpha: 0.5,
          color: "#FF5733",
        },
        highlight: {
          fontColor: "#000",
        },
        textAlign: "center",
      },
    });

  const [uploadedUrls, setUploadedUrls] = useState({
    leftTop: {
      fileName: "",
      fileUrl: "",
      enabled: false,
    },
    leftBottom: {
      fileName: "",
      fileUrl: "",
      enabled: false,
    },
    rightTop: {
      fileName: "",
      fileUrl: "",
      enabled: false,
    },
    rightBottom: {
      fileName: "",
      fileUrl: "",
      enabled: false,
    },
    splashVideo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    splashVideoTwo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    splashLogoMedia: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    closedLogoMedia: {
      fileName: "",
      fileUrl: "",
      enabled: false,
    },
    closedVideo: {
      fileName: "",
      fileUrl: "",
      enabled: true,
    },
  });

  const [menuuploadedUrls, setMenuUploadedUrls] = useState({
    leftTop: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    leftBottom: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    rightTop: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    rightBottom: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    splashVideo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    splashVideotwo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    splashVideothree: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    centerLogo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    centerBelowMenuMedia: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    backMenuMedia: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
  });

  const [selectedMainMenuUploadedUrls, setSelectedMainMenuUploadedUrls] =
    useState({
      leftTop: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        width: 0,
        height: 0,
        disabledPadding: false,
        disabledMargin: false,
      },
      leftBottom: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        width: 0,
        height: 0,
      },
      rightTop: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        width: 0,
        height: 0,
      },
      rightBottom: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        width: 0,
        height: 0,
      },
      splashVideo: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        captionFile: "",
      },
      splashVideotwo: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        captionFile: "",
      },
      splashVideothree: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        captionFile: "",
      },
      centerLogo: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        width: 0,
        height: 0,
      },
      centerBelowMenuMedia: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        width: 0,
        height: 0,
      },
      backMenuMedia: {
        fileName: "",
        fileUrl: "",
        enabled: false,
        width: 0,
        height: 0,
      },
    });

  const videoRef = useRef(null);
  const [playCount, setPlayCount] = useState(0);

  // Restart splash video when toggleState changes (for screenSteps === 1)
  useEffect(() => {
    if (screenSteps === 1 && videoRef.current) {
      const currentVideoUrl = toggleState
        ? uploadedUrls?.splashVideoTwo?.enabled &&
          uploadedUrls?.splashVideoTwo?.fileUrl
          ? uploadedUrls?.splashVideoTwo?.fileUrl
          : uploadedUrls?.splashVideo?.fileUrl
        : uploadedUrls?.splashVideo?.enabled &&
          uploadedUrls?.splashVideo?.fileUrl
          ? uploadedUrls?.splashVideo?.fileUrl
          : uploadedUrls?.splashVideoTwo?.fileUrl;

      console.log("🎬 Splash video toggle state changed, restarting video...", {
        screenSteps,
        toggleState,
        currentVideoUrl,
        splashVideoEnabled: uploadedUrls?.splashVideo?.enabled,
        splashVideoTwoEnabled: uploadedUrls?.splashVideoTwo?.enabled,
      });

      if (currentVideoUrl) {
        setTimeout(() => {
          if (videoRef.current && screenSteps === 1) {
            console.log("🎬 Restarting splash video playback...");

            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            videoRef.current.load();

            const playPromise = videoRef.current.play();

            if (playPromise !== undefined) {
              playPromise
                .then(() => {
                  console.log(
                    "✅ Splash video playing successfully after toggle",
                  );
                })
                .catch((err) => {
                  console.error(
                    "❌ Error auto-playing splash video after toggle:",
                    err,
                  );
                  // Try muted play as fallback
                  videoRef.current.muted = true;
                  videoRef.current
                    .play()
                    .then(() => {
                      console.log("✅ Splash video playing muted after toggle");
                      setTimeout(() => {
                        if (videoRef.current) {
                          videoRef.current.muted = false;
                        }
                      }, 100);
                    })
                    .catch((e) =>
                      console.error("❌ Muted play also failed:", e),
                    );
                });
            }
          }
        }, 200);
      }
    }
  }, [
    toggleState,
    // uploadedUrls?.splashVideo?.fileUrl,
    // uploadedUrls?.splashVideoTwo?.fileUrl,
    // uploadedUrls?.splashVideo?.enabled,
    // uploadedUrls?.splashVideoTwo?.enabled,
    // screenSteps,
  ]);

  const [settings, setSettings] = useState({
    userId: null,
    globalSettings: {
      height: 50,
      width: 150,
      font: "Arial",
      fontColor: "#127E10",
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: "#FF5733",
      },
      highlight: {
        fontColor: "#000",
      },
      textAlign: "center",
    },
    enabled: false,
  });

  const [lineHeight, setLineHeight] = useState(0.6);
  const [padding, setPadding] = useState(20);
  const [fontSize, setFontSize] = useState(20);

  useEffect(() => {
    fetchMedia(client_url);

    if (!hasUpdated.current) {
      setIsSecondView((prev) => prev + 1);
      hasUpdated.current = true;
    }
  }, [client_url]);

  // Fetch Next Navigation settings for a submenu parent (global for all content pages)
  const fetchSubMenuNextNavSettings = async (parentMenuId) => {
    try {
      console.log(
        "Fetching Next Navigation settings for parent:",
        parentMenuId,
      );
      const response = await axios.get(
        `/api/frontendview-main-settings/${parentMenuId}`,
      );
      const settings = response.data?.finalSettings || {};

      // Store settings globally for this submenu
      subMenuNextNavSettings.current = {
        enableNextNavigation: settings.enableNextNavigation || false,
        nextButtonTopOffset: settings.nextButtonTopOffset ?? null,
        nextButtonLeftOffset: settings.nextButtonLeftOffset ?? null,
        nextButtonRightOffset: settings.nextButtonRightOffset ?? null,
        nextButtonBottomOffset: settings.nextButtonBottomOffset ?? null,
      };

      // Also update the current refs for immediate use
      enableNextNavigation.current =
        subMenuNextNavSettings.current.enableNextNavigation;
      nextButtonTopOffset.current =
        subMenuNextNavSettings.current.nextButtonTopOffset;
      nextButtonLeftOffset.current =
        subMenuNextNavSettings.current.nextButtonLeftOffset;
      nextButtonRightOffset.current =
        subMenuNextNavSettings.current.nextButtonRightOffset;
      nextButtonBottomOffset.current =
        subMenuNextNavSettings.current.nextButtonBottomOffset;

      console.log(
        "Next Navigation settings loaded:",
        subMenuNextNavSettings.current,
      );
    } catch (error) {
      console.error(
        "Error fetching Next Navigation settings:",
        error?.response?.data || error.message,
      );
      // Reset to defaults on error
      subMenuNextNavSettings.current = {
        enableNextNavigation: false,
        nextButtonTopOffset: null,
        nextButtonLeftOffset: null,
        nextButtonRightOffset: null,
        nextButtonBottomOffset: null,
      };
    }
  };

  // Handler for next button navigation in SubMenu (CONTENT PAGES ONLY)
  const handleSubMenuNextNavigation = async () => {
    console.log(
      "SubMenu Next Navigation - Current Content Index:",
      currentSubMenuContentIndex,
    );
    console.log("Current parent ref:", currentSubMenuParentRef.current);
    console.log("Current userSteps:", userSteps);
    console.log("Current userStepsArr:", userStepsArr);

    const currentParentId = currentSubMenuParentRef.current;

    if (!currentParentId) {
      console.log("No parent ID found, going back to main menu");
      setIsSecondView((prev) => prev + 1);
      fetchMedia(client_url);
      setScreenSteps(2);
      setCurrentSubMenuContentIndex(-1);
      setUserSteps(0);
      setUserStepsArr([]);
      setUserBtnSession([]);
      return;
    }

    // Get ALL submenu items for current parent
    const allSubMenuItems = [...(primarySubMenu || [])]
      .filter((e) => e.parentId === currentParentId)
      .sort((a, b) => a.order - b.order);

    // Filter to get ONLY content pages (no links, no wayfinder, no trivia, no children)
    const contentPages = allSubMenuItems.filter((item) => isContentPage(item));

    console.log("Current parent ID:", currentParentId);
    console.log("Total submenu items:", allSubMenuItems.length);
    console.log("Content pages only:", contentPages.length);
    console.log(
      "Content pages:",
      contentPages.map((item) => ({
        id: item.id,
        name: item.name,
        order: item.order,
      })),
    );

    if (contentPages.length === 0) {
      console.log("No content pages in submenu, going back to main menu");
      setIsSecondView((prev) => prev + 1);
      fetchMedia(client_url);
      setScreenSteps(2);
      setCurrentSubMenuContentIndex(-1);
      currentSubMenuParentRef.current = null;
      setUserSteps(0);
      setUserStepsArr([]);
      setUserBtnSession([]);
      return;
    }

    const nextIndex = currentSubMenuContentIndex + 1;

    console.log("Next content page index:", nextIndex);

    if (nextIndex >= contentPages.length) {
      // Reached end of content pages, go back to parent menu (submenu with buttons)
      console.log("Reached end of content pages, going back to parent menu");

      // Find the parent menu's step in userStepsArr to reset navigation properly
      const parentStep = (userStepsArr || []).find(
        (e) => e.linkbtnId === currentParentId,
      );

      console.log("Parent step found:", parentStep);

      if (parentStep) {
        // Reset userSteps to parent's step so back button works correctly
        setUserSteps(parentStep.userSteps);
        // Keep only steps UP TO AND INCLUDING the parent step (RESET TRACKING)
        setUserStepsArr((prevSteps) =>
          prevSteps.filter((step) => step.userSteps <= parentStep.userSteps),
        );
      } else {
        // If parent step not found, reset to step 1 (first submenu level)
        console.log("Parent step not found, resetting to step 1");
        setUserSteps(1);
        setUserStepsArr((prevSteps) => prevSteps.slice(0, 1));
      }

      // Reset content index and parent ref
      setCurrentSubMenuContentIndex(-1);
      currentSubMenuParentRef.current = null;

      // Clear Next Navigation settings since we're back to submenu with buttons
      subMenuNextNavSettings.current = {
        enableNextNavigation: false,
        nextButtonTopOffset: null,
        nextButtonLeftOffset: null,
        nextButtonRightOffset: null,
        nextButtonBottomOffset: null,
      };

      // Load the submenu with buttons using subBackhandleAnimationComplete
      await subBackhandleAnimationComplete(currentParentId, currentParentId);
    } else {
      const nextItem = contentPages[nextIndex];
      console.log(`Navigating to content page ${nextIndex}:`, nextItem.name);

      setCurrentSubMenuContentIndex(nextIndex);

      // Store the current parent ID before navigation
      const preservedParentId = currentParentId;

      // Increment userSteps and add to history (TRACK THE PATH)
      setUserSteps((prevUserSteps) => {
        const nextUserStep = prevUserSteps + 1;

        const newItem = {
          userSteps: nextUserStep,
          menuId: nextItem.id,
          linkbtnId: nextItem.linkbtnId ? nextItem.linkbtnId : nextItem.id,
        };

        setUserStepsArr((prevSteps) => {
          // Check if this exact step already exists
          const exists = prevSteps.some(
            (step) =>
              step.userSteps === newItem.userSteps &&
              step.menuId === newItem.menuId &&
              step.linkbtnId === newItem.linkbtnId,
          );
          if (exists) return prevSteps;
          return [...prevSteps, newItem];
        });

        console.log("Added to navigation history:", newItem);
        return nextUserStep;
      });

      // Load the content
      try {
        const response = await axios.get(
          `/api/get-btnpage-content/${nextItem.linkbtnId ? nextItem.linkbtnId : nextItem.id}/${selectedLanguage}`,
        );
        const mediaData = extractContentFromResponse(response.data);

        // Update content display
        setMenuContent(mediaData?.contenttype);
        setExternalweblink(mediaData?.externalweblink);
        setSelectedMainMenuVideoTime(mediaData?.videotime || 0);

        setSelectedMainMenuUploadedUrls((prevUrls) => ({
          ...prevUrls,
          leftTop: {
            fileName: mediaData?.leftTop?.fileName || "",
            fileUrl: mediaData?.leftTop?.fileUrl || "",
            enabled: mediaData?.leftTop?.enabled || false,
            width: mediaData?.leftTop?.width || 0,
            height: mediaData?.leftTop?.height || 0,
            disabledPadding: mediaData?.leftTop?.disabledPadding || false,
            disabledMargin: mediaData?.leftTop?.disabledMargin || false,
          },
          leftBottom: {
            fileName: mediaData?.leftBottom?.fileName || "",
            fileUrl: mediaData?.leftBottom?.fileUrl || "",
            enabled: mediaData?.leftBottom?.enabled || false,
            width: mediaData?.leftBottom?.width || 0,
            height: mediaData?.leftBottom?.height || 0,
          },
          rightTop: {
            fileName: mediaData?.rightTop?.fileName || "",
            fileUrl: mediaData?.rightTop?.fileUrl || "",
            enabled: mediaData?.rightTop?.enabled || false,
            width: mediaData?.rightTop?.width || 0,
            height: mediaData?.rightTop?.height || 0,
          },
          rightBottom: {
            fileName: mediaData?.rightBottom?.fileName || "",
            fileUrl: mediaData?.rightBottom?.fileUrl || "",
            enabled: mediaData?.rightBottom?.enabled || false,
            width: mediaData?.rightBottom?.width || 0,
            height: mediaData?.rightBottom?.height || 0,
          },
          splashVideo: {
            fileName: mediaData?.splashVideo?.fileName || "",
            fileUrl: mediaData?.splashVideo?.fileUrl || "",
            enabled: mediaData?.splashVideo?.enabled || false,
            captionFile: mediaData?.splashVideo?.captionFile || "",
          },
          splashVideotwo: {
            fileName: mediaData?.splashVideotwo?.fileName || "",
            fileUrl: mediaData?.splashVideotwo?.fileUrl || "",
            enabled: mediaData?.splashVideotwo?.enabled || false,
            captionFile: mediaData?.splashVideotwo?.captionFile || "",
          },
          splashVideothree: {
            fileName: mediaData?.splashVideothree?.fileName || "",
            fileUrl: mediaData?.splashVideothree?.fileUrl || "",
            enabled: mediaData?.splashVideothree?.enabled || false,
            captionFile: mediaData?.splashVideothree?.captionFile || "",
          },
          centerLogo: {
            fileName: mediaData?.centerLogoMedia?.fileName || "",
            fileUrl: mediaData?.centerLogoMedia?.fileUrl || "",
            enabled: mediaData?.centerLogoMedia?.enabled || false,
            width: mediaData?.centerLogoMedia?.width || 0,
            height: mediaData?.centerLogoMedia?.height || 0,
          },
          centerBelowMenuMedia: {
            fileName: mediaData?.centerBelowMenuMedia?.fileName || "",
            fileUrl: mediaData?.centerBelowMenuMedia?.fileUrl || "",
            enabled: mediaData?.centerBelowMenuMedia?.enabled || false,
            width: mediaData?.centerBelowMenuMedia?.width || 0,
            height: mediaData?.centerBelowMenuMedia?.height || 0,
          },
          backMenuMedia: {
            fileName: mediaData?.backMenuMedia?.fileName || "",
            fileUrl: mediaData?.backMenuMedia?.fileUrl || "",
            enabled: mediaData?.backMenuMedia?.enabled || false,
            width: mediaData?.backMenuMedia?.width || 0,
            height: mediaData?.backMenuMedia?.height || 0,
          },
        }));

        setSelectedMainMenuSplashText(
          getTextForLanguage(
            mediaData?.splashText,
            mediaData?.splashText ?? "",
          ),
        );
        setSelectedMainMenuTextSettings((prevSettings) => ({
          ...prevSettings,
          globalSettings: {
            ...prevSettings?.globalSettings,
            ...mediaData?.globalSettings,
          },
        }));

        // Clear selectedParentMenu to show content page without buttons
        setSelectedParentMenu([]);

        // Restore the parent ref
        currentSubMenuParentRef.current = preservedParentId;

        // Set screen to content display
        setScreenSteps(3);

        console.log("Next navigation complete - tracking path");
      } catch (err) {
        console.error("Error in handleSubMenuNextNavigation:", err);
      }
    }
  };

  // Handler for previous button navigation in SubMenu (CONTENT PAGES ONLY)
  const handleSubMenuPreviousNavigation = async () => {
    const currentParentId = currentSubMenuParentRef.current;
    if (!currentParentId || currentSubMenuContentIndex <= 0) {
      // At first content page — go back to the parent submenu (with buttons), not main menu
      setCurrentSubMenuContentIndex(-1);
      currentSubMenuParentRef.current = null;
      enableNextNavigation.current = false;

      // Find the parent step in userStepsArr so we can navigate back properly
      const parentStep = (userStepsArr || []).find(
        (e) => e.linkbtnId === currentParentId,
      );

      if (parentStep) {
        setUserSteps(parentStep.userSteps);
        setUserStepsArr((prevSteps) =>
          prevSteps.filter((step) => step.userSteps <= parentStep.userSteps),
        );
        await subBackhandleAnimationComplete(
          parentStep.menuId,
          parentStep.linkbtnId,
        );
      } else {
        // Fallback: go to main menu cleanly
        setUserSteps(0);
        setUserStepsArr([]);
        setUserBtnSession([]);
        setIsSecondView((prev) => prev + 1);
        await fetchMedia(client_url);
        setScreenSteps(2);
      }
      return;
    }
  };

  // Handler for previous button navigation in Main Menu (CONTENT PAGES ONLY)
  const handleMainMenuPreviousNavigation = async () => {
    if (currentMainMenuContentIndex <= 0) {
      // Go back to main menu
      setIsSecondView((prev) => prev + 1);
      await fetchMedia(client_url);
      setScreenSteps(2);
      setCurrentMainMenuContentIndex(-1);
      return;
    }
    const allMainMenuItems = [...(frontendMainMenu || [])].sort(
      (a, b) => a.order - b.order,
    );
    const contentPages = allMainMenuItems.filter((item) => isContentPage(item));
    const prevIndex = currentMainMenuContentIndex - 1;
    const prevItem = contentPages[prevIndex];
    setCurrentMainMenuContentIndex(prevIndex);
    await handleTextClick(prevItem.id, prevItem.linkbtnId);
  };

  // Handler for next button navigation in Main Menu (CONTENT PAGES ONLY)
  const handleMainMenuNextNavigation = async () => {
    console.log(
      "Main Menu Next Navigation - Current Content Index:",
      currentMainMenuContentIndex,
    );

    // Get ALL main menu items sorted by order
    const allMainMenuItems = [...(frontendMainMenu || [])].sort(
      (a, b) => a.order - b.order,
    );

    // Filter to get ONLY content pages (no links, no wayfinder, no trivia, no children)
    const contentPages = allMainMenuItems.filter((item) => isContentPage(item));

    console.log("Total main menu items:", allMainMenuItems.length);
    console.log("Content pages only:", contentPages.length);

    if (contentPages.length === 0) {
      console.log("No content pages in main menu");
      return;
    }

    const nextIndex = currentMainMenuContentIndex + 1;

    if (nextIndex >= contentPages.length) {
      // Reached end of content pages, go back to parent menu (main menu)
      console.log("Reached end of content pages, going back to main menu");
      setIsSecondView((prev) => prev + 1);
      await fetchMedia(client_url);
      setScreenSteps(2);
      setCurrentMainMenuContentIndex(-1);
    } else {
      // Navigate to next content page
      const nextItem = contentPages[nextIndex];
      console.log(`Navigating to content page ${nextIndex}:`, nextItem.name);

      setCurrentMainMenuContentIndex(nextIndex);
      await handleTextClick(nextItem.id, nextItem.linkbtnId);
    }
  };

  const fetchMedia = async (client_url) => {
    // Cancel previous request if exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    
    // Create new AbortController for this request
    abortControllerRef.current = new AbortController();
    
    try {
      const response = await axios.get(`/api/button/frontend/${client_url}`, {
        params: { language: selectedLanguage },
        signal: abortControllerRef.current.signal
      });
      
      // Check if component is still mounted before updating state
      if (!isMountedRef.current) return;
      
      if (!response.data.error) {
        const mediaData = response.data?.result;
        const settings = response.data?.settings;
        const menuPage = response.data?.menuPage;
        const menuMediaPage = response.data?.userMenuMedia;
        const menuTextSettingsrep = response.data?.menuTextSettings;
        const contentSchema = response.data?.contentSchema;

        setBrandColor(response.data?.brandcolor);
        setBrandFont(response.data?.brandFont);
        setLineHeight(response.data?.lineHeight);
        setPadding(response.data?.padding);
        setFontSize(response.data?.fontSize);


        // Fetch Airtable configuration after setting userId

        setUploadedUrls((prevUrls) => ({
          ...prevUrls,
          leftTop: {
            fileName: mediaData?.leftTop?.fileName || "",
            fileUrl: mediaData?.leftTop?.fileUrl || "",
            enabled: mediaData?.leftTop?.enabled || false,
          },
          leftBottom: {
            fileName: mediaData?.leftBottom?.fileName || "",
            fileUrl: mediaData?.leftBottom?.fileUrl || "",
            enabled: mediaData?.leftBottom?.enabled || false,
          },
          rightTop: {
            fileName: mediaData?.rightTop?.fileName || "",
            fileUrl: mediaData?.rightTop?.fileUrl || "",
            enabled: mediaData?.rightTop?.enabled || false,
          },
          rightBottom: {
            fileName: mediaData?.rightBottom?.fileName || "",
            fileUrl: mediaData?.rightBottom?.fileUrl || "",
            enabled: mediaData?.rightBottom?.enabled || false,
          },
          splashVideo: {
            fileName: mediaData?.splashVideo?.fileName || "",
            fileUrl: mediaData?.splashVideo?.fileUrl || "",
            enabled: mediaData?.splashVideo?.enabled || false,
            captionFile: mediaData?.splashVideo?.captionFile || "",
          },
          splashVideoTwo: {
            fileName: mediaData?.splashVideoTwo?.fileName || "",
            fileUrl: mediaData?.splashVideoTwo?.fileUrl || "",
            enabled: mediaData?.splashVideoTwo?.enabled || false,
            captionFile: mediaData?.splashVideoTwo?.captionFile || "",
          },
          splashLogoMedia: {
            fileName: mediaData?.splashLogoMedia?.fileName || "",
            fileUrl: mediaData?.splashLogoMedia?.fileUrl || "",
            enabled: mediaData?.splashLogoMedia?.enabled || false,
            width: mediaData?.splashLogoMedia?.width || 0,
            height: mediaData?.splashLogoMedia?.height || 0,
          },
          closedLogoMedia: {
            fileName: mediaData?.closedLogoMedia?.fileName || "",
            fileUrl: mediaData?.closedLogoMedia?.fileUrl || "",
            enabled: mediaData?.closedLogoMedia?.enabled || false,
          },
          closedVideo: {
            fileName: mediaData?.closedVideo?.fileName || "",
            fileUrl: mediaData?.closedVideo?.fileUrl || "",
            enabled: mediaData?.closedVideo?.enabled || false,
          },
        }));

        setUserId(mediaData.userId);

        setSplashText(
          getTextForLanguage(
            mediaData?.splashText,
            mediaData?.splashText ?? "",
          ),
        );
        setSplashTextDownload(
          getTextForLanguage(
            mediaData?.splashTextDownload,
            mediaData?.splashTextDownload ?? "",
          ),
        );
        setSplashVideoTime(mediaData?.videotime || 0);
        setHeightOffset(mediaData?.heightoffset || 0);
        setLeftOffSetSplash(mediaData?.leftoffset);

        setMenuUploadedUrls((prevUrls) => ({
          ...prevUrls,
          leftTop: {
            fileName: menuMediaPage?.leftTop?.fileName || "",
            fileUrl: menuMediaPage?.leftTop?.fileUrl || "",
            enabled: menuMediaPage?.leftTop?.enabled || false,
            width: menuMediaPage?.leftTop?.width || 0,
            height: menuMediaPage?.leftTop?.height || 0,
          },
          leftBottom: {
            fileName: menuMediaPage?.leftBottom?.fileName || "",
            fileUrl: menuMediaPage?.leftBottom?.fileUrl || "",
            enabled: menuMediaPage?.leftBottom?.enabled || false,
            width: menuMediaPage?.leftBottom?.width || 0,
            height: menuMediaPage?.leftBottom?.height || 0,
          },
          rightTop: {
            fileName: menuMediaPage?.rightTop?.fileName || "",
            fileUrl: menuMediaPage?.rightTop?.fileUrl || "",
            enabled: menuMediaPage?.rightTop?.enabled || false,
            width: menuMediaPage?.rightTop?.width || 0,
            height: menuMediaPage?.rightTop?.height || 0,
          },
          rightBottom: {
            fileName: menuMediaPage?.rightBottom?.fileName || "",
            fileUrl: menuMediaPage?.rightBottom?.fileUrl || "",
            enabled: menuMediaPage?.rightBottom?.enabled || false,
            width: menuMediaPage?.rightBottom?.width || 0,
            height: menuMediaPage?.rightBottom?.height || 0,
          },
          splashVideo: {
            fileName: menuMediaPage?.splashVideo?.fileName || "",
            fileUrl: menuMediaPage?.splashVideo?.fileUrl || "",
            enabled: menuMediaPage?.splashVideo?.enabled || false,
            captionFile: menuMediaPage?.splashVideo?.captionFile || "",
          },
          splashVideotwo: {
            fileName: menuMediaPage?.splashVideotwo?.fileName || "",
            fileUrl: menuMediaPage?.splashVideotwo?.fileUrl || "",
            enabled: menuMediaPage?.splashVideotwo?.enabled || false,
            captionFile: menuMediaPage?.splashVideotwo?.captionFile || "",
          },
          splashVideothree: {
            fileName: menuMediaPage?.splashVideothree?.fileName || "",
            fileUrl: menuMediaPage?.splashVideothree?.fileUrl || "",
            enabled: menuMediaPage?.splashVideothree?.enabled || false,
            captionFile: menuMediaPage?.splashVideothree?.captionFile || "",
          },
          centerLogo: {
            fileName: menuMediaPage?.centerLogo?.fileName || "",
            fileUrl: menuMediaPage?.centerLogo?.fileUrl || "",
            enabled: menuMediaPage?.centerLogo?.enabled || false,
            width: menuMediaPage?.centerLogo?.width || 0,
            height: menuMediaPage?.centerLogo?.height || 0,
          },
          centerBelowMenuMedia: {
            fileName: menuMediaPage?.centerBelowMenuMedia?.fileName || "",
            fileUrl: menuMediaPage?.centerBelowMenuMedia?.fileUrl || "",
            enabled: menuMediaPage?.centerBelowMenuMedia?.enabled || false,
            width: menuMediaPage?.centerBelowMenuMedia?.width || 0,
            height: menuMediaPage?.centerBelowMenuMedia?.height || 0,
          },
          backMenuMedia: {
            fileName: menuMediaPage?.menuBackButton?.fileName || "",
            fileUrl: menuMediaPage?.menuBackButton?.fileUrl || "",
            enabled: menuMediaPage?.menuBackButton?.enabled || false,
            width: menuMediaPage?.menuBackButton?.width || 0,
            height: menuMediaPage?.menuBackButton?.height || 0,
          },
        }));

        setGlobalSettings(
          response.data?.globalSettings?.globalSettings || globalSettings,
        );

        // Extract wayfinder global sound settings
        const fetchedGlobalSettings = response.data?.globalSettings?.globalSettings || {};
        setWayfinderGlobalSoundSettings({
          clickSound: fetchedGlobalSettings.clickSound || "",
          clickSoundVolume: fetchedGlobalSettings.clickSoundVolume || 1,
        });

        console.log("Global settings after fetch:", globalSettings);
        console.log("Wayfinder global sound settings:", {
          clickSound: fetchedGlobalSettings.clickSound || "",
          clickSoundVolume: fetchedGlobalSettings.clickSoundVolume || 1,
        });

        if (mediaData?.userId) {
          await fetchAirtableConfig(mediaData.userId);
          await fetchButtonSettings(mediaData.userId);
        }

        let videoList = [];
        const responselang = await axios.get(`/api/language/${mediaData.userId}`);
        if (responselang.data.success) {
          const languages = responselang.data.languages || [];


          // If we have available languages, fetch content for all of them
          if (languages.length > 0) {
            console.log("🌐 Fetching media content for all languages:", languages);

            for (const lang of languages) {
              try {
                const langResponse = await axios.get(`/api/button/frontend/${client_url}`, {
                  params: { language: lang },
                });

                if (!langResponse.data.error) {
                  const langMediaData = langResponse.data?.result;
                  const langMenuMediaPage = langResponse.data?.userMenuMedia;
                  const langContentSchema = langResponse.data?.contentSchema;

                  // Collect videos for this language
                  const splashKeys = ["splashVideo", "splashVideotwo", "splashVideothree"];

                  splashKeys.forEach((key) => {
                    const video = langMenuMediaPage?.[key];
                    if (video?.enabled && video.fileUrl) {
                      const decodedUrl = decodeURIComponent(video.fileUrl);
                      const fileName = decodedUrl.split("/").pop();
                      videoList.push({
                        url: video.fileUrl,
                        key: `${fileName}_${lang}`, // Add language to key
                        // language: lang,
                        // type: "menu_video",
                        // videoKey: key
                      });
                    }
                  });

                  // Splash front videos
                  const splashFront = langMediaData?.splashVideo;
                  if (splashFront?.enabled && splashFront.fileUrl) {
                    const splashdecodedUrl = decodeURIComponent(splashFront.fileUrl);
                    const splashfileName = splashdecodedUrl.split("/").pop();
                    videoList.push({
                      url: splashFront.fileUrl,
                      key: `${splashfileName}_${lang}`,
                      // language: lang,
                      // type: "splash_video",
                      // videoKey: "splashVideo"
                    });
                  }

                  const splashFrontTwo = langMediaData?.splashVideoTwo;
                  if (splashFrontTwo?.enabled && splashFrontTwo.fileUrl) {
                    const splashTwodecodedUrl = decodeURIComponent(splashFrontTwo.fileUrl);
                    const splashTwofileName = splashTwodecodedUrl.split("/").pop();
                    videoList.push({
                      url: splashFrontTwo.fileUrl,
                      key: `${splashTwofileName}_${lang}`,
                      // language: lang,
                      // type: "splash_video",
                      // videoKey: "splashVideoTwo"
                    });
                  }

                  // Content schema videos
                  (langContentSchema || []).forEach((item, index) => {
                    ["splashVideo", "splashVideotwo", "splashVideothree"].forEach((key) => {
                      if (item[key] && item[key].enabled && item[key].fileUrl) {
                        const contentdecodedUrl = decodeURIComponent(item[key].fileUrl);
                        const contentfileName = contentdecodedUrl.split("/").pop();
                        videoList.push({
                          url: item[key].fileUrl,
                          key: `${contentfileName}_${lang}`,
                          // language: lang,
                          // type: "content_video",
                          // videoKey: key,
                          // contentIndex: index
                        });
                      }
                    });
                  });

                  // Closed Video Splash Screen for this language
                  const closedVideo = langMediaData?.closedVideo;
                  if (closedVideo?.enabled && closedVideo.fileUrl) {
                    const closedVideodecodedUrl = decodeURIComponent(closedVideo.fileUrl);
                    const closedVideoName = closedVideodecodedUrl.split("/").pop();
                    videoList.push({
                      url: closedVideo.fileUrl,
                      key: `${closedVideoName}_${lang}`,
                      // language: lang,
                      // type: "closed_video"
                    });
                  }
                }
              } catch (langError) {
                console.error(`Error fetching media for language ${lang}:`, langError);
              }

              // Mappedin Videos
              try {
                console.log("🎬 Fetching location videos for preloading...");
                const locationVideoResponse = await axios.get(
                  `/api/location-videos/preload-videos/${mediaData.userId}`,
                  {
                    params: { language: lang },
                  },
                );

                if (
                  locationVideoResponse.data.success &&
                  locationVideoResponse.data.data.length > 0
                ) {

                  // Add location videos to the video list
                  locationVideoResponse.data.data.forEach((locationVideo) => {
                    if (locationVideo.url && locationVideo.key) {
                      videoList.push({
                        url: locationVideo.url,
                        key: `${locationVideo.key}_${lang}`,
                        type: locationVideo.type || "location_video",
                        locationId: locationVideo.locationId,
                        locationName: locationVideo.locationName,
                      });
                    }
                  });


                } else {
                  console.log("ℹ️ No location videos found for preloading");
                }
              } catch (locationVideoError) {
                console.error(
                  "❌ Error fetching location videos for preloading:",
                  locationVideoError,
                );
                // Don't fail the entire process if location videos can't be fetched
              }
            }
          }

        }



        // const splashKeys = [
        //   "splashVideo",
        //   "splashVideotwo",
        //   "splashVideothree",
        // ];

        // splashKeys.forEach((key) => {
        //   const video = menuMediaPage?.[key];
        //   if (video?.enabled && video.fileUrl) {
        //     const decodedUrl = decodeURIComponent(video.fileUrl);
        //     const fileName = decodedUrl.split("/").pop();
        //     videoList.push({ url: video.fileUrl, key: fileName });
        //   }
        // });

        // const splashFront = mediaData?.splashVideo;
        // if (splashFront?.enabled && splashFront.fileUrl) {
        //   const splashdecodedUrl = decodeURIComponent(splashFront.fileUrl);
        //   const splashfileName = splashdecodedUrl.split("/").pop();
        //   videoList.push({ url: splashFront.fileUrl, key: splashfileName });
        // }

        // const splashFrontTwo = mediaData?.splashVideoTwo;
        // if (splashFrontTwo?.enabled && splashFrontTwo.fileUrl) {
        //   const splashTwodecodedUrl = decodeURIComponent(
        //     splashFrontTwo.fileUrl,
        //   );
        //   const splashTwofileName = splashTwodecodedUrl.split("/").pop();
        //   videoList.push({
        //     url: splashFrontTwo.fileUrl,
        //     key: splashTwofileName,
        //   });
        // }

        // (contentSchema || []).forEach((item) => {
        //   ["splashVideo", "splashVideotwo", "splashVideothree"].forEach(
        //     (key) => {
        //       if (item[key] && item[key].enabled && item[key].fileUrl) {
        //         const contentdecodedUrl = decodeURIComponent(item[key].fileUrl);
        //         const contentfileName = contentdecodedUrl.split("/").pop();
        //         videoList.push({
        //           url: item[key].fileUrl,
        //           key: contentfileName,
        //         });
        //       }
        //     },
        //   );
        // });

        // // Closed Video Splash Screen
        // const closedVideo = mediaData?.closedVideo;
        // if (closedVideo?.enabled && closedVideo.fileUrl) {
        //   const closedVideodecodedUrl = decodeURIComponent(closedVideo.fileUrl);
        //   const closedVideoName = closedVideodecodedUrl.split("/").pop();
        //   videoList.push({ url: closedVideo.fileUrl, key: closedVideoName });
        // }

        // Add Airtable videos to the main video list

        // Fetch and add location videos to the video list

        setVideoList(videoList);
        setMenuSplashText(
          getTextForLanguage(
            menuMediaPage?.splashText,
            menuMediaPage?.splashText ?? "",
          ),
        );
        setVideoTime(
          menuMediaPage?.videotime || response?.data?.menuMediaVideoTime,
        );

        setSettings((prevSettings) => ({
          ...prevSettings,
          globalSettings: {
            ...prevSettings?.globalSettings,
            ...settings?.globalSettings,
          },
        }));

        setMenuTextSettings((prevSettings) => ({
          ...prevSettings,
          globalSettings: {
            ...prevSettings?.globalSettings,
            ...menuTextSettingsrep?.globalSettings,
          },
        }));

        console.log("Menu text settings after fetch:", menuPage);

        const menus = (menuPage || [])
          .map((menu, index) => ({
            id: menu._id,
            name: getTextForLanguage(menu.name, menu.name),
            isVisible: menu.isVisible,
            settings: !menu.mainsettings[0]?.enabled
              ? menu.mainsettings[0]?.globalSettings
              : menu.mainsettings[0]?.customSettings,
            side: index % 2 === 0 ? "left" : "right",
          }))
          .filter((menu) => menu.isVisible);

        const submenus = (menuPage || []).flatMap((menu) =>
          menu.submenus
            .filter((submenu) => submenu.isVisible)
            .map((submenu, index) => ({
              parentId: menu._id,
              id: submenu._id,
              name: getTextForLanguage(submenu.name, submenu.name),
              linkbtnId: submenu?.linkbtnId,
              linkedTrivia: submenu?.linkedTrivia,
              linkedWayfinder: submenu?.linkedWayfinder,
              mainMeuLinked: submenu?.mainMeuLinked,
              settings: !submenu?.details?.enabled
                ? submenu?.details?.globalSettings
                : submenu?.details?.customSettings,
              side: index % 2 === 0 ? "left" : "right",
            })),
        );

        const frontMenu = response.data?.frontendMainMenu;
        const frontMenuArr = (frontMenu || [])
          .map((menu, index) => ({
            id: menu._id,
            name: getTextForLanguage(menu.name, menu.name),
            isVisible: menu.isVisible,
            settings: !menu.mainsettings[0]?.enabled
              ? menu.mainsettings[0]?.globalSettings
              : menu.mainsettings[0]?.customSettings,
            side: index % 2 === 0 ? "left" : "right",
            linkbtnId: menu?.linkbtnId,
            linkedTrivia: menu?.linkedTrivia,
            linkedWayfinder: menu?.linkedWayfinder,
          }))
          .filter((menu) => menu.isVisible);

        setFrontendMainMenu(frontMenuArr);
        setPrimaryMenu(menus);
        setPrimarySubMenu(submenus);
        setCurrentUserId(mediaData?.userId);

        try {
          const response2 = await axios.get(
            `/api/frontend-main-settings/${mediaData?.userId}`,
          );
          const mediaData2 = response2.data;

          numColumns.current =
            mediaData2?.numColumns || "center-two-buttons-per-row";
          columnSpacing.current = mediaData2?.columnSpacing || 5;
          enableOffset.current = mediaData2?.enableOffset || false;
          leftOffset.current = mediaData2?.leftOffset || 5;
          rightOffset.current = mediaData2?.rightOffset || 0;
          topOffset.current = mediaData2?.topOffset || 5;
          disableAnimation.current = mediaData2?.disableAnimation || false;

          enableVideoEndOffset.current =
            mediaData2?.enableVideoEndOffset || false;
          videoEndLeftOffset.current = mediaData2?.videoEndLeftOffset || 0;
          videoEndRightOffset.current = mediaData2?.videoEndRightOffset || 0;
          videoEndTopOffset.current = mediaData2?.videoEndTopOffset || 5;




          enableVideoEndNavigation.current = mediaData2?.enableVideoEndNavigation || false;
          videoEndNavigationMenuId.current = mediaData2?.videoEndNavigationMenuId || null;

          // Wheelchair content offset
          wheelchairContentOffsetY.current = mediaData2?.wheelchairContentOffsetY ?? 20;
        } catch (error) {
          console.error(
            "Error fetching main settings:",
            error?.response?.data || error.message,
          );
        }

        // Override splash video enabled flags with localStorage values (for toggle feature)
        const splashVideoKey = `splashVideoEnabled_${client_url}`;
        const splashVideoTwoKey = `splashVideoTwoEnabled_${client_url}`;

        const video1EnabledLS = localStorage.getItem(splashVideoKey);
        const video2EnabledLS = localStorage.getItem(splashVideoTwoKey);

        // Only override if localStorage values exist (toggle has been used)
        if (video1EnabledLS !== null || video2EnabledLS !== null) {
          console.log(
            "🎬 Overriding splash video enabled flags from localStorage after fetchMedia",
          );

          setUploadedUrls((prevUrls) => ({
            ...prevUrls,
            splashVideo: {
              ...prevUrls.splashVideo,
              enabled: video1EnabledLS === "true",
            },
            splashVideoTwo: {
              ...prevUrls.splashVideoTwo,
              enabled: video2EnabledLS === "true",
            },
          }));
        }
      }
    } catch (error) {
      // Ignore abort errors
      if (axios.isCancel(error) || error.name === 'CanceledError') {
        console.log('Request cancelled');
        return;
      }
      console.error("Failed to fetch media data:", error);
    }
  };

  const handleVideoPlay = () => {
    console.log("Video is playing...", playCount);
    const videoElement = videoRef.current;
    console.log("videoElement", videoElement);
    if (videoElement) {
      videoElement.muted = false;
    }
  };

  const [clicked, setClicked] = useState(false);
  const [subclicked, setSubClicked] = useState(false);
  const [selectedParentMenu, setSelectedParentMenu] = useState([]);

  // Wayfinder navigation functions
  const handleWayfinderNavigation = async (buttonItem) => {
    console.log("🔵 Wayfinder navigation triggered:", buttonItem);


    const linkedWayfinder = buttonItem.linkedWayfinder;
    if (!linkedWayfinder || !linkedWayfinder.status) {
      console.log("❌ No wayfinder configuration found");
      return false;
    }

    try {
      // Store the linkedWayfinder configuration for use in rendering
      setCurrentWayfinderConfig(linkedWayfinder);


      // Store the button ID for wayfinder
      setCurrentWayfinderButtonId(buttonItem.id);

      // Track entry point based on current screen
      // screenSteps: 2 = main menu, 3+ = submenu/content pages
      const entryPoint = screenSteps === 2 ? "mainMenu" : "subMenu";
      setWayfinderEntryPoint(entryPoint);
      setWayfinderPreviousScreen(screenSteps);


      // Store current userSteps and userStepsArr for proper back navigation
      const wayfinderNavigationState = {
        userSteps: userSteps,
        userStepsArr: [...userStepsArr],
        screenSteps: screenSteps,
        entryPoint: entryPoint,
      };


      console.log(`🔵 Wayfinder entry point: ${entryPoint}, previous screen: ${screenSteps}, userSteps: ${userSteps}`);
      console.log("🔵 Stored navigation state:", wayfinderNavigationState);

      // Fetch branding settings for all wayfinder screens
      console.log("🔵 Fetching branding settings for userId:", currentUserId);
      const brandingResponse = await axios.get(
        `/api/wayfinder/branding-settings/${currentUserId}`,
      );

      if (brandingResponse.data.success) {
        const searchSettings = brandingResponse.data.data;
        setWayfinderSearchSettings(searchSettings);
        setWayfinderBackButton(searchSettings.backButton);
        setWayfinderQRCodeSettings(searchSettings.qrCode);
        setWayfinderQrCodeConfig(searchSettings.qrCodeConfig)
        setWayfinderMapPositionSettings(searchSettings.mapPosition);
        setWayfinderReplayPopupSettings(searchSettings.replayPopup);
        setLogoBeforeMap(searchSettings?.logoBeforeMap)
        console.log("✅ Branding settings loaded");
      }

      // Use the unified API endpoint to get locations based on button configuration
      console.log("🔵 Fetching wayfinder locations from unified API");
      const locationsResponse = await axios.get(
        `/api/wayfinder-button/locations/${currentUserId}/${buttonItem.id}/${selectedLanguage}`,
      );

      if (!locationsResponse.data.success) {
        console.error(
          "❌ Failed to fetch wayfinder locations:",
          locationsResponse.data.message,
        );
        return false;
      }

      const { data: locations, mode } = locationsResponse.data;
      console.log(`✅ Fetched ${locations.length} locations in ${mode} mode`);

      // Handle different navigation modes
      if (mode === "directLocation") {
        // Direct location - navigate to avatar screen
        console.log("🔵 Direct location mode - navigating to avatar screen");


        // Store the mode so we know there's no search screen
        setWayfinderMode('directLocation');

        if (locations.length > 0) {
          setWayfinderLocationData(locations[0]);
          setShowWayfinderAvatar(true);
          setShowWayfinderSearch(false);
          setShowWayfinderCategory(false);
          setScreenSteps(10);
        }
        return true;
      }

      if (mode === "categories") {
        // Categories mode - show search screen with filtered locations
        console.log(
          "🔵 Categories mode - showing search screen with filtered locations",
        );


        // Store the mode
        setWayfinderMode('categories');

        // Transform locations to match search screen format
        const searchData = locations.map((loc, index) => ({
          id: loc._id || loc.id,
          _id: loc._id || loc.id,
          name: loc.name,
          buttonText: loc.buttonText || loc.name,
          photo: loc.photo || loc.uploadedUrls?.locationPhoto?.fileUrl,
          order: loc.order || index,
          type: "location",
          spaceName: loc.spaceName || "",
          custom: loc.custom || false,
          globalSettings: loc.globalSettings || {
            fillColor: "#ffffff",
            fontColor: brandColor || "#000000",
            outlineColor: brandColor || "#000000",
            outlineThickness: 2,
            cornerRadius: 8,
            fontSize: 18,
            fontWeight: 600,
            padding: 15,
            width: 200,
            height: 200,
          },
          customSettings: loc.customSettings || {},
        }));

        console.log(
          `✅ Transformed ${searchData.length} locations for search screen`,
        );

        setWayfinderSearchData(searchData);
        setShowWayfinderSearch(true);
        setShowWayfinderCategory(false);
        setShowWayfinderSubCategory(false);
        setScreenSteps(9);
        return true;
      }

      if (mode === "searchPage") {
        // Search page mode - show all locations
        console.log("🔵 Search page mode - showing all locations");


        // Store the mode
        setWayfinderMode('searchPage');

        // Transform locations to match search screen format
        const searchData = locations.map((loc, index) => ({
          id: loc._id || loc.id,
          _id: loc._id || loc.id,
          name: loc.name,
          buttonText: loc.buttonText || loc.name,
          photo: loc.photo || loc.uploadedUrls?.locationPhoto?.fileUrl,
          order: loc.order || index,
          type: "location",
          spaceName: loc.spaceName || "",
          custom: loc.custom || false,
          globalSettings: loc.globalSettings || {
            fillColor: "#ffffff",
            fontColor: brandColor || "#000000",
            outlineColor: brandColor || "#000000",
            outlineThickness: 2,
            cornerRadius: 8,
            fontSize: 18,
            fontWeight: 600,
            padding: 15,
            width: 200,
            height: 200,
          },
          customSettings: loc.customSettings || {},
        }));

        console.log(
          `✅ Transformed ${searchData.length} locations for search screen`,
        );

        setWayfinderSearchData(searchData);
        setShowWayfinderSearch(true);
        setShowWayfinderCategory(false);
        setShowWayfinderSubCategory(false);
        setScreenSteps(9);
        return true;
      }



      console.warn("⚠️ Unknown navigation mode:", mode);
      return false;
    } catch (error) {
      console.error("❌ Error in wayfinder navigation:", error);
      return false;
    } finally {
      try {
        await axios.post("/api/log/button-click", {
          btnId: buttonItem?.id,
          client_url,
          language: selectedLanguage,
        });
      } catch (error) {
        console.error("Failed to save media data:", error);
      }
      console.log("🔵 Wayfinder navigation process complete");
    }
  };

  // const handleWayfinderBack = (destination) => {
  //   console.log("🔵 Wayfinder back navigation, destination:", destination);
  //   console.log("🔵 Entry point:", wayfinderEntryPoint);
  //   console.log("🔵 Previous screen:", wayfinderPreviousScreen);
  //   console.log("🔵 Current showWayfinderAvatar:", showWayfinderAvatar);
  //   console.log("🔵 Current showWayfinderSearch:", showWayfinderSearch);

  //   // If destination is explicitly 'mainMenu', go to main menu
  //   if (destination === 'mainMenu') {
  //     console.log("🔵 Going to MAIN MENU (forced)");
  //     setShowWayfinderSearch(false);
  //     setShowWayfinderAvatar(false);
  //     setShowWayfinderCategory(false);
  //     setShowWayfinderSubCategory(false);
  //     setWayfinderSearchData([]);
  //     setWayfinderLocationData([]);
  //     setWayfinderEntryPoint(null);
  //     setWayfinderPreviousScreen(null);
  //     setScreenSteps(2); // Main menu
  //     return;
  //   }

  //   // If we're on avatar screen, go back to search
  //   if (showWayfinderAvatar) {
  //     setShowWayfinderAvatar(false);
  //     setWayfinderLocationData(null);
  //     setShowWayfinderSearch(true);
  //     setScreenSteps(9);
  //     return;
  //   }

  //   // If we're on search screen, go back to where we came from
  //   if (showWayfinderSearch) {
  //     setShowWayfinderSearch(false);
  //     setWayfinderSearchData([]);

  //     // Return to the screen we came from
  //     if (wayfinderPreviousScreen) {
  //       setScreenSteps(wayfinderPreviousScreen);
  //     } else if (wayfinderEntryPoint === 'mainMenu') {
  //       setScreenSteps(2); // Main menu
  //     } else {
  //       setScreenSteps(3); // Submenu/content page
  //     }

  //     // Clear wayfinder state
  //     setWayfinderEntryPoint(null);
  //     setWayfinderPreviousScreen(null);
  //     return;
  //   }

  //   // Default: go back to main menu
  //   setShowWayfinderSearch(false);
  //   setShowWayfinderAvatar(false);
  //   setWayfinderSearchData([]);
  //   setWayfinderLocationData(null);
  //   setWayfinderEntryPoint(null);
  //   setWayfinderPreviousScreen(null);
  //   setScreenSteps(2);
  // };

  const handleWayfinderBack = (destination) => {
    console.log("🔵 Wayfinder back navigation, destination:", destination);
    console.log("🔵 Entry point:", wayfinderEntryPoint);
    console.log("🔵 Previous screen:", wayfinderPreviousScreen);
    console.log("🔵 Wayfinder mode:", wayfinderMode);
    console.log("🔵 Current userSteps:", userSteps);
    console.log("🔵 Current userStepsArr:", userStepsArr);
    console.log("🔵 Current showWayfinderAvatar:", showWayfinderAvatar);
    console.log("🔵 Current showWayfinderSearch:", showWayfinderSearch);

    // If destination is explicitly 'mainMenu', go to main menu
    if (destination === 'mainMenu') {
      console.log("🔵 Going to MAIN MENU (forced)");
      setShowWayfinderSearch(false);
      setShowWayfinderAvatar(false);
      setShowWayfinderCategory(false);
      setShowWayfinderSubCategory(false);
      setWayfinderSearchData([]);
      setWayfinderLocationData(null);
      setWayfinderEntryPoint(null);
      setWayfinderPreviousScreen(null);
      setCurrentWayfinderConfig(null);
      setCurrentWayfinderButtonId(null);
      setWayfinderMode(null);

      // Reset to main menu state
      setScreenSteps(2);
      setUserSteps(0);
      setUserStepsArr([]);
      setUserBtnSession([]);
      setSelectedParentMenu([]);
      currentSubMenuParentRef.current = null;
      setCurrentSubMenuContentIndex(-1);
      setCurrentMainMenuContentIndex(-1);
      enableNextNavigation.current = false;
      setIsSecondView((prev) => prev + 1);
      fetchMedia(client_url);
      return;
    }

    // If we're on avatar screen
    if (showWayfinderAvatar) {
      // Check if this was a direct location (no search screen)
      if (wayfinderMode === 'directLocation') {
        console.log("🔵 Direct location mode - going back to previous menu (no search screen)");

        // Clear wayfinder state
        setShowWayfinderAvatar(false);
        setWayfinderLocationData(null);
        setShowWayfinderSearch(false);
        setWayfinderSearchData([]);
        setCurrentWayfinderConfig(null);
        setCurrentWayfinderButtonId(null);
        setWayfinderMode(null);

        // Return to the screen we came from
        if (wayfinderPreviousScreen !== null) {
          console.log(`🔵 Returning to previous screen: ${wayfinderPreviousScreen}`);
          setScreenSteps(wayfinderPreviousScreen);
        } else if (wayfinderEntryPoint === 'mainMenu') {
          console.log("🔵 Returning to main menu (entry point)");
          setScreenSteps(2);
        } else if (wayfinderEntryPoint === 'subMenu') {
          console.log("🔵 Returning to submenu (entry point)");
          setScreenSteps(3);
        } else {
          console.log("🔵 No entry point found, defaulting to main menu");
          setScreenSteps(2);
        }


        // Clear wayfinder-specific state but preserve navigation state
        setWayfinderEntryPoint(null);
        setWayfinderPreviousScreen(null);
        return;
      } else {
        // Categories or searchPage mode - go back to search screen
        console.log("🔵 On avatar screen, going back to search");
        setShowWayfinderAvatar(false);
        setWayfinderLocationData(null);
        setShowWayfinderSearch(true);
        setScreenSteps(9);
        return;
      }
    }

    // If we're on search screen, go back to where we came from
    if (showWayfinderSearch) {
      console.log("🔵 On search screen, going back to entry point");
      setShowWayfinderSearch(false);
      setWayfinderSearchData([]);
      setCurrentWayfinderConfig(null);
      setCurrentWayfinderButtonId(null);
      setWayfinderMode(null);

      // Return to the screen we came from using the stored navigation state
      if (wayfinderPreviousScreen !== null) {
        console.log(`🔵 Returning to previous screen: ${wayfinderPreviousScreen}`);
        setScreenSteps(wayfinderPreviousScreen);


      } else if (wayfinderEntryPoint === 'mainMenu') {
        console.log("🔵 Returning to main menu (entry point)");
        setScreenSteps(2);
        // Don't reset userSteps here - keep the navigation history intact


      } else if (wayfinderEntryPoint === 'subMenu') {
        console.log("🔵 Returning to submenu (entry point)");
        setScreenSteps(3);
        // Don't reset userSteps here - keep the navigation history intact


      } else {
        console.log("🔵 No entry point found, defaulting to main menu");
        setScreenSteps(2);
      }

      // Clear wayfinder-specific state but preserve navigation state
      setWayfinderEntryPoint(null);
      setWayfinderPreviousScreen(null);
      return;
    }

    // Default: go back to main menu
    console.log("🔵 Default case: going to main menu");
    setShowWayfinderSearch(false);
    setShowWayfinderAvatar(false);
    setShowWayfinderCategory(false);
    setShowWayfinderSubCategory(false);
    setWayfinderSearchData([]);
    setWayfinderLocationData(null);
    setWayfinderEntryPoint(null);
    setWayfinderPreviousScreen(null);
    setCurrentWayfinderConfig(null);
    setCurrentWayfinderButtonId(null);
    setWayfinderMode(null);
    setScreenSteps(2);
  };

  const handleWayfinderItemSelect = async (item) => {
    console.log("=== Wayfinder Item Selection Debug ===");
    console.log("Wayfinder item selected:", item);
    console.log("Current userId:", currentUserId);

    try {
      let locationId = item.id || item._id;

      // Handle direct location navigation from search results
      if (item.isDirectLocation && item.directLocationId) {
        console.log(
          "Direct location navigation from search:",
          item.directLocationId,
        );
        locationId = item.directLocationId;
      }

      console.log("Fetching location data for ID:", locationId);
      console.log(
        "API URL:",
        `/api/wayfinder/location/${currentUserId}/${locationId}`,
      );

      const locationResponse = await axios.get(
        `/api/wayfinder/location/${currentUserId}/${locationId}`,
      );

      console.log("Location API response:", locationResponse.data);

      if (locationResponse.data.success) {
        console.log(
          "Location data fetched successfully:",
          locationResponse.data.data,
        );

        // Log location button click
        try {
          await axios.post("/api/log/location-button-click", {
            locationId: locationId,
            client_url: client_url,
            clickedLocationName: locationResponse.data.data.name[selectedLanguage || 'en'] || item.name[selectedLanguage || 'en'] || "Unknown Location",
            buttonType: "location",
            categoryId: item.categoryId || null,
            subcategoryId: item.subcategoryId || null,
            language: selectedLanguage
          });
          console.log("Location button click logged successfully");
        } catch (logError) {
          console.error("Failed to log location button click:", logError);
        }

        setWayfinderLocationData(locationResponse.data.data);
        setShowWayfinderSearch(false);
        setShowWayfinderAvatar(true);
        setScreenSteps(10); // Navigate to avatar screen
        console.log(
          "Avatar screen should now be visible. ScreenSteps set to 10",
        );
      } else {
        console.error("Failed to fetch location data:", locationResponse.data);
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
      console.error("Error details:", error.response?.data);
    }
  };

  const handleTextClick = async (menuId, linkbtnId, buttonItem = null) => {
    console.log("handleTextClick called:", {
      menuId,
      linkbtnId,
      currentUserSteps: userSteps,
      userStepsArr,
    });

    isSubMenuSecondView.current = false;
    isSubMenuThirdView.current = false;

    try {
      const response = await axios.get(
        `/api/get-btnpage-content/${linkbtnId ? linkbtnId : menuId}/${selectedLanguage}`,
      );
      const mediaData = extractContentFromResponse(response.data);
      const newItem = { id: linkbtnId ? linkbtnId : menuId };
      const exists = (userBtnSession || []).filter(
        (item) => item.id === newItem.id,
      );
      if (exists.length === 0) {
        isSubMenuSecondView.current = false;
        isSubMenuThirdView.current = false;
      } else if (exists.length === 1) {
        isSubMenuSecondView.current = true;
        isSubMenuThirdView.current = false;
      } else {
        isSubMenuSecondView.current = false;
        isSubMenuThirdView.current = true;
      }
      setUserBtnSession((prevItems) => [...prevItems, newItem]);
      setCurrentMenuId(newItem?.id);
      setMenuContent(mediaData?.contenttype);
      setExternalweblink(mediaData?.externalweblink);

      setSelectedMainMenuUploadedUrls((prevUrls) => ({
        ...prevUrls,
        leftTop: {
          fileName: mediaData?.leftTop?.fileName || "",
          fileUrl: mediaData?.leftTop?.fileUrl || "",
          enabled: mediaData?.leftTop?.enabled || false,
          width: mediaData?.leftTop?.width || 0,
          height: mediaData?.leftTop?.height || 0,
          disabledPadding: mediaData?.leftTop?.disabledPadding || false,
          disabledMargin: mediaData?.leftTop?.disabledMargin || false,
        },
        leftBottom: {
          fileName: mediaData?.leftBottom?.fileName || "",
          fileUrl: mediaData?.leftBottom?.fileUrl || "",
          enabled: mediaData?.leftBottom?.enabled || false,
          width: mediaData?.leftBottom?.width || 0,
          height: mediaData?.leftBottom?.height || 0,
        },
        rightTop: {
          fileName: mediaData?.rightTop?.fileName || "",
          fileUrl: mediaData?.rightTop?.fileUrl || "",
          enabled: mediaData?.rightTop?.enabled || false,
          width: mediaData?.rightTop?.width || 0,
          height: mediaData?.rightTop?.height || 0,
        },
        rightBottom: {
          fileName: mediaData?.rightBottom?.fileName || "",
          fileUrl: mediaData?.rightBottom?.fileUrl || "",
          enabled: mediaData?.rightBottom?.enabled || false,
          width: mediaData?.rightBottom?.width || 0,
          height: mediaData?.rightBottom?.height || 0,
        },
        splashVideo: {
          fileName: mediaData?.splashVideo?.fileName || "",
          fileUrl: mediaData?.splashVideo?.fileUrl || "",
          enabled: mediaData?.splashVideo?.enabled || false,
          captionFile: mediaData?.splashVideo?.captionFile || "",
        },
        splashVideotwo: {
          fileName: mediaData?.splashVideotwo?.fileName || "",
          fileUrl: mediaData?.splashVideotwo?.fileUrl || "",
          enabled: mediaData?.splashVideotwo?.enabled || false,
          captionFile: mediaData?.splashVideotwo?.captionFile || "",
        },
        splashVideothree: {
          fileName: mediaData?.splashVideothree?.fileName || "",
          fileUrl: mediaData?.splashVideothree?.fileUrl || "",
          enabled: mediaData?.splashVideothree?.enabled || false,
          captionFile: mediaData?.splashVideothree?.captionFile || "",
        },
        centerLogo: {
          fileName: mediaData?.centerLogoMedia?.fileName || "",
          fileUrl: mediaData?.centerLogoMedia?.fileUrl || "",
          enabled: mediaData?.centerLogoMedia?.enabled || false,
          width: mediaData?.centerLogoMedia?.width || 0,
          height: mediaData?.centerLogoMedia?.height || 0,
        },
        centerBelowMenuMedia: {
          fileName: mediaData?.centerBelowMenuMedia?.fileName || "",
          fileUrl: mediaData?.centerBelowMenuMedia?.fileUrl || "",
          enabled: mediaData?.centerBelowMenuMedia?.enabled || false,
          width: mediaData?.centerBelowMenuMedia?.width || 0,
          height: mediaData?.centerBelowMenuMedia?.height || 0,
        },
        backMenuMedia: {
          fileName: mediaData?.backMenuMedia?.fileName || "",
          fileUrl: mediaData?.backMenuMedia?.fileUrl || "",
          enabled: mediaData?.backMenuMedia?.enabled || false,
          width: mediaData?.backMenuMedia?.width || 0,
          height: mediaData?.backMenuMedia?.height || 0,
        },
      }));
      setSelectedMainMenuSplashText(
        getTextForLanguage(mediaData?.splashText, mediaData?.splashText ?? ""),
      );
      setSelectedMainMenuVideoTime(mediaData?.videotime || 0);
      setSelectedMainMenuTextSettings((prevSettings) => ({
        ...prevSettings,
        globalSettings: {
          ...prevSettings?.globalSettings,
          ...mediaData?.globalSettings,
        },
      }));

      setParentMenuId(menuId);
      setClickedLinkedId(linkbtnId ? linkbtnId : menuId);
    } catch (err) {
      console.error("Error in handleTextClick:", err);
    }

    setClicked(true);

    if (linkbtnId) {
      const filtersubmenu = (primarySubMenu || []).filter(
        (e) => e.parentId === linkbtnId,
      );
      setSelectedParentMenu(filtersubmenu);
    } else {
      setSelectedParentMenu([]);
    }

    // Increment userSteps
    const nextUserStep = userSteps + 1;
    setUserSteps(nextUserStep);

    const newItem = {
      userSteps: nextUserStep,
      menuId: menuId,
      linkbtnId: linkbtnId ? linkbtnId : menuId,
    };

    setUserStepsArr((prevSteps) => {
      // Check if this exact step already exists
      const exists = prevSteps.some(
        (step) =>
          step.userSteps === newItem.userSteps &&
          step.menuId === newItem.menuId &&
          step.linkbtnId === newItem.linkbtnId,
      );
      if (exists) return prevSteps;
      return [...prevSteps, newItem];
    });

    try {
      await axios.post("/api/log/button-click", {
        btnId: menuId,
        client_url,
        language: selectedLanguage,
      });
    } catch (error) {
      console.error("Failed to save media data:", error);
    }
  };

  // Handle Airtable video selection
  const handleAirtableVideoSelect = (videoData) => {
    setAirtableVideoData(videoData);
  };

  const handleAnimationComplete = async () => {


    if (clicked) {
      if (!triviaQuiz) {
        try {
          const response2 = await axios.get(
            `/api/frontendview-main-settings/${clickedLinkedId ? clickedLinkedId : parentMenuId}`,
          );
          const mediaData2 = response2.data;

          numColumns.current = mediaData2?.finalSettings?.numColumns;
          columnSpacing.current = mediaData2?.finalSettings?.columnSpacing || 5;
          enableOffset.current =
            mediaData2?.finalSettings?.enableOffset || false;
          leftOffset.current = mediaData2?.finalSettings?.leftOffset || 5;
          rightOffset.current = mediaData2?.finalSettings?.rightOffset || 0;
          topOffset.current = mediaData2?.finalSettings?.topOffset || 5;
          disableAnimation.current =
            mediaData2?.finalSettings?.disableAnimation || false;

          //////////////////////////////------------------------////////////////
          enableVideoEndOffset.current =
            mediaData2?.finalSettings?.enableVideoEndOffset || false;
          videoEndTopOffset.current =
            mediaData2?.finalSettings?.videoEndTopOffset || 5;
          videoEndLeftOffset.current =
            mediaData2?.finalSettings?.videoEndLeftOffset || 0;
          videoEndRightOffset.current =
            mediaData2?.finalSettings?.videoEndRightOffset || 0;
          enableVideoEndOffset.current =
            mediaData2?.finalSettings?.enableVideoEndOffset || false;
          videoEndTopOffset.current =
            mediaData2?.finalSettings?.videoEndTopOffset || 5;
          videoEndLeftOffset.current =
            mediaData2?.finalSettings?.videoEndLeftOffset || 0;
          videoEndRightOffset.current =
            mediaData2?.finalSettings?.videoEndRightOffset || 0;

          // Next Navigation Button settings
          enableNextNavigation.current =
            mediaData2?.finalSettings?.enableNextNavigation || false;
          nextButtonTopOffset.current =
            mediaData2?.finalSettings?.nextButtonTopOffset ?? null;
          nextButtonLeftOffset.current =
            mediaData2?.finalSettings?.nextButtonLeftOffset ?? null;
          nextButtonRightOffset.current =
            mediaData2?.finalSettings?.nextButtonRightOffset ?? null;
          nextButtonBottomOffset.current =
            mediaData2?.finalSettings?.nextButtonBottomOffset ?? null;

          enableVideoEndNavigation.current = mediaData2?.finalSettings?.enableVideoEndNavigation || false;
          videoEndNavigationMenuId.current = mediaData2?.finalSettings?.videoEndNavigationMenuId || null;

          // Wheelchair content offset
          wheelchairContentOffsetY.current = mediaData2?.finalSettings?.wheelchairContentOffsetY ?? 20;

          // Set currentMainMenuContentIndex when landing on main menu content page
          const mainMenuContentPages = [...(frontendMainMenu || [])]
            .filter((item) => isContentPage(item))
            .sort((a, b) => a.order - b.order);
          const mainContentIdx = mainMenuContentPages.findIndex(
            (item) => item.id === (clickedLinkedId || parentMenuId),
          );
          if (mainContentIdx >= 0) {
            setCurrentMainMenuContentIndex(mainContentIdx);
            currentSubMenuParentRef.current = null;
          } else {
            setCurrentMainMenuContentIndex(-1);
            setCurrentSubMenuContentIndex(-1);
            // Entering submenu - set parent ref for next navigation
            if (clickedLinkedId) {
              currentSubMenuParentRef.current = clickedLinkedId;
              // Fetch Next Navigation settings for this submenu parent (global for all content pages)
              await fetchSubMenuNextNavSettings(clickedLinkedId);
            }
          }
          /////////////////////////////////////////////////////////////////////
        } catch (error) {
          console.error(
            "Error fetching main settings:",
            error?.response?.data || error.message,
          );
        }
        setScreenSteps(3);
      } else {
        const response = await axios.get(
          `/api/topic-main-settings/${currentUserId}/${selectedLanguage}`,
        );
        const triviaSettings = response.data;

        setTriviaQuizSettings(triviaSettings);
        await axios
          .get(`/api/trivia-topics-menu/${currentUserId}/${selectedLanguage}`)
          .then((response) => {
            if (response.data.error) {
              showErrorToast("No Trivia Quiz Topic Found");
            } else {
              const filterMenus = response.data?.data.triviaquizmenu || [];

              const menus = (filterMenus || [])
                .map((menu, index) => ({
                  id: menu._id,
                  name: getTextForLanguage(menu.name, menu.name),
                  isVisible: menu.isVisible,
                  side: index % 2 === 0 ? "left" : "right",
                }))
                .filter((menu) => menu.isVisible);

              setTriviaQuizTopics(menus);
            }
          })
          .catch((error) => {
            console.error("Error fetching menus:", error);
          });
        setScreenSteps(4);
      }
      setClicked(false);
    }
  };

  const subMenuVideoEndNavigation = async () => {
    try {
      setIsSecondView((prev) => prev + 1);
      await fetchMedia(client_url);

      setScreenSteps(2);
      setUserSteps(0);
      setUserStepsArr([]);
      setUserBtnSession([]);
      setSelectedParentMenu([]);
      setSubClicked(false);
      return;
    }
    catch (error) {
      console.log("error", error)
    }
  }

  const subhandleAnimationComplete = async () => {
    console.log("Clicked Link ID and BUTTON", clickedLinkedId, parentMenuId);

    console.log("Selectd PArent menu", selectedParentMenu)

    if (subclicked) {
      const checkMainMenu = (selectedParentMenu || [])
        .filter((e) => e.id === parentMenuId)
        .some((d) => d.mainMeuLinked);

      console.log("CheckMain menu", checkMainMenu)
      if (checkMainMenu) {
        setIsSecondView((prev) => prev + 1);
        await fetchMedia(client_url);

        setScreenSteps(2);
        setUserSteps(0);
        setUserStepsArr([]);
        setUserBtnSession([]);
        setSelectedParentMenu([]);
        setSubClicked(false);
        return;
      }

      if (!triviaQuiz) {
        numColumns.current = null;
        columnSpacing.current = null;
        enableOffset.current = null;
        leftOffset.current = null;
        topOffset.current = null;
        rightOffset.current = null;
        disableAnimation.current = null;
        isSubMenuSecondView.current = false;
        isSubMenuThirdView.current = false;

        enableVideoEndOffset.current = null;
        videoEndTopOffset.current = null;
        videoEndLeftOffset.current = null;
        videoEndRightOffset.current = null;
        enableVideoEndOffset.current = null;
        videoEndTopOffset.current = null;
        videoEndLeftOffset.current = null;
        videoEndRightOffset.current = null;
        try {
          const response = await axios.get(
            `/api/get-btnpage-content/${clickedLinkedId ? clickedLinkedId : parentMenuId
            }/${selectedLanguage}`,
          );
          const mediaData = extractContentFromResponse(response.data);
          const newItem = {
            id: clickedLinkedId ? clickedLinkedId : parentMenuId,
          };
          const exists = (userBtnSession || []).filter(
            (item) => item.id === newItem.id,
          );
          if (exists.length === 0) {
            isSubMenuSecondView.current = false;
            isSubMenuThirdView.current = false;
          } else if (exists.length === 1) {
            isSubMenuSecondView.current = true;
            isSubMenuThirdView.current = false;
          } else {
            isSubMenuSecondView.current = false;
            isSubMenuThirdView.current = true;
          }
          setUserBtnSession((prevItems) => [...prevItems, newItem]);
          setCurrentMenuId(newItem?.id);

          setMenuBackButton(mediaData?.menuBackButton || false);
          setMenuContent(mediaData?.contenttype);
          setExternalweblink(mediaData?.externalweblink);
          setSelectedMainMenuVideoTime(mediaData?.videotime || 0);

          setSelectedMainMenuUploadedUrls((prevUrls) => ({
            ...prevUrls,
            leftTop: {
              fileName: mediaData?.leftTop?.fileName || "",
              fileUrl: mediaData?.leftTop?.fileUrl || "",
              enabled: mediaData?.leftTop?.enabled || false,
              width: mediaData?.leftTop?.width || 0,
              height: mediaData?.leftTop?.height || 0,
              disabledPadding: mediaData?.leftTop?.disabledPadding || false,
              disabledMargin: mediaData?.leftTop?.disabledMargin || false,
            },
            leftBottom: {
              fileName: mediaData?.leftBottom?.fileName || "",
              fileUrl: mediaData?.leftBottom?.fileUrl || "",
              enabled: mediaData?.leftBottom?.enabled || false,
              width: mediaData?.leftBottom?.width || 0,
              height: mediaData?.leftBottom?.height || 0,
            },
            rightTop: {
              fileName: mediaData?.rightTop?.fileName || "",
              fileUrl: mediaData?.rightTop?.fileUrl || "",
              enabled: mediaData?.rightTop?.enabled || false,
              width: mediaData?.rightTop?.width || 0,
              height: mediaData?.rightTop?.height || 0,
            },
            rightBottom: {
              fileName: mediaData?.rightBottom?.fileName || "",
              fileUrl: mediaData?.rightBottom?.fileUrl || "",
              enabled: mediaData?.rightBottom?.enabled || false,
              width: mediaData?.rightBottom?.width || 0,
              height: mediaData?.rightBottom?.height || 0,
            },
            splashVideo: {
              fileName: mediaData?.splashVideo?.fileName || "",
              fileUrl: mediaData?.splashVideo?.fileUrl || "",
              enabled: mediaData?.splashVideo?.enabled || false,
              captionFile: mediaData?.splashVideo?.captionFile || "",
            },
            splashVideotwo: {
              fileName: mediaData?.splashVideotwo?.fileName || "",
              fileUrl: mediaData?.splashVideotwo?.fileUrl || "",
              enabled: mediaData?.splashVideotwo?.enabled || false,
              captionFile: mediaData?.splashVideotwo?.captionFile || "",
            },
            splashVideothree: {
              fileName: mediaData?.splashVideothree?.fileName || "",
              fileUrl: mediaData?.splashVideothree?.fileUrl || "",
              enabled: mediaData?.splashVideothree?.enabled || false,
              captionFile: mediaData?.splashVideothree?.captionFile || "",
            },
            centerLogo: {
              fileName: mediaData?.centerLogoMedia?.fileName || "",
              fileUrl: mediaData?.centerLogoMedia?.fileUrl || "",
              enabled: mediaData?.centerLogoMedia?.enabled || false,
            },
            centerBelowMenuMedia: {
              fileName: mediaData?.centerBelowMenuMedia?.fileName || "",
              fileUrl: mediaData?.centerBelowMenuMedia?.fileUrl || "",
              enabled: mediaData?.centerBelowMenuMedia?.enabled || false,
            },
            backMenuMedia: {
              fileName: mediaData?.backMenuMedia?.fileName || "",
              fileUrl: mediaData?.backMenuMedia?.fileUrl || "",
              enabled: mediaData?.backMenuMedia?.enabled || false,
              width: mediaData?.backMenuMedia?.width || 0,
              height: mediaData?.backMenuMedia?.height || 0,
            },
          }));
          try {
            const response2 = await axios.get(
              `/api/frontendview-main-settings/${clickedLinkedId ? clickedLinkedId : parentMenuId}`,
            );

            console.log(
              "Fetched main settings successfully for submenu content:",
              response2.data,
            );

            const mediaData2 = response2.data;

            numColumns.current =
              mediaData2?.finalSettings?.numColumns ||
              "center-two-buttons-per-row";
            columnSpacing.current =
              mediaData2?.finalSettings?.columnSpacing || 5;
            enableOffset.current =
              mediaData2?.finalSettings?.enableOffset || false;
            leftOffset.current = mediaData2?.finalSettings?.leftOffset || 5;
            rightOffset.current = mediaData2?.finalSettings?.rightOffset || 0;
            topOffset.current = mediaData2?.finalSettings?.topOffset || 5;
            disableAnimation.current =
              mediaData2?.finalSettings?.disableAnimation || false;

            enableVideoEndOffset.current =
              mediaData2?.finalSettings?.enableVideoEndOffset || false;

            videoEndLeftOffset.current =
              mediaData2?.finalSettings?.videoEndLeftOffset || 0;

            videoEndRightOffset.current =
              mediaData2?.finalSettings?.videoEndRightOffset || 0;

            videoEndTopOffset.current =
              mediaData2?.finalSettings?.videoEndTopOffset || 5;

            // Wheelchair content offset
            wheelchairContentOffsetY.current = mediaData2?.finalSettings?.wheelchairContentOffsetY ?? 20;

            setSubMenuSettings((prev) => ({
              ...prev,
              columnSpacing: mediaData2?.finalSettings?.columnSpacing || 5,
              numColumns:
                mediaData2?.finalSettings?.numColumns ||
                "center-two-buttons-per-row",
              enableOffset: mediaData2?.finalSettings?.enableOffset || false,
              leftOffset: mediaData2?.finalSettings?.leftOffset || 5,
              rightOffset: mediaData2?.finalSettings?.rightOffset || 0,
              topOffset: mediaData2?.finalSettings?.topOffset || 5,
              disableAnimation:
                mediaData2?.finalSettings?.disableAnimation || false,

              enableVideoEndOffset:
                mediaData2?.finalSettings?.enableVideoEndOffset || false,

              videoEndLeftOffset:
                mediaData2?.finalSettings?.videoEndLeftOffset || 0,

              videoEndRightOffset:
                mediaData2?.finalSettings?.videoEndRightOffset || 0,

              videoEndTopOffset:
                mediaData2?.finalSettings?.videoEndTopOffset || 5,
            }));
          } catch (error) {
            console.error(
              "Error fetching main settings:",
              error?.response?.data || error.message,
            );
          }

          if (clickedLinkedId) {
            const filtersubmenu = (primarySubMenu || []).filter(
              (e) => e.parentId === clickedLinkedId,
            );
            setSelectedParentMenu(filtersubmenu);
          } else {
            // Landing on submenu content page - set index for Next Navigation
            const currentParentId = (selectedParentMenu || [])[0]?.parentId;
            setSelectedParentMenu([]);
            if (currentParentId) {
              currentSubMenuParentRef.current = currentParentId;

              // Fetch Next Navigation settings for this submenu parent (global for all content pages)
              await fetchSubMenuNextNavSettings(currentParentId);

              const subContentPages = [...(primarySubMenu || [])]
                .filter((e) => e.parentId === currentParentId)
                .filter((item) => isContentPage(item))
                .sort((a, b) => a.order - b.order);
              const contentIdx = subContentPages.findIndex(
                (item) => item.id === parentMenuId,
              );
              if (contentIdx >= 0) {
                setCurrentSubMenuContentIndex(contentIdx);
              }
            }
          }

          setScreenSteps(3);
          setSubClicked(false);
          setParentMenuId(null);
          setClickedLinkedId(null);
        } catch (error) {
          console.error("Failed to save media data:", error);
        }
      } else {
        const response = await axios.get(
          `/api/topic-main-settings/${currentUserId}/${selectedLanguage}`,
        );
        const triviaSettings = response.data;

        setTriviaQuizSettings(triviaSettings);
        await axios
          .get(`/api/trivia-topics-menu/${currentUserId}/${selectedLanguage}`)
          .then((response) => {
            if (response.data.error) {
              showErrorToast("No Trivia Quiz Topic Found");
            } else {
              const filterMenus = response.data?.data.triviaquizmenu || [];

              const menus = (filterMenus || [])
                .map((menu, index) => ({
                  id: menu._id,
                  name: getTextForLanguage(menu.name, menu.name),
                  isVisible: menu.isVisible,
                  side: index % 2 === 0 ? "left" : "right",
                }))
                .filter((menu) => menu.isVisible);

              setTriviaQuizTopics(menus);
            }
          })
          .catch((error) => {
            console.error("Error fetching menus:", error);
          });
        setScreenSteps(4);
      }
    }
  };

  const subBackhandleAnimationComplete = async (menuId, linkbtnId) => {
    console.log("subBackhandleAnimationComplete called:", {
      menuId,
      linkbtnId,
      currentUserSteps: userSteps,
    });

    numColumns.current = null;
    columnSpacing.current = null;
    enableOffset.current = null;
    leftOffset.current = null;
    rightOffset.current = null;
    topOffset.current = null;
    disableAnimation.current = null;
    isSubMenuSecondView.current = false;
    isSubMenuThirdView.current = false;
    try {
      const response = await axios.get(
        `/api/get-btnpage-content/${linkbtnId ? linkbtnId : menuId}/${selectedLanguage}`,
      );
      const mediaData = extractContentFromResponse(response.data);
      const newItem = { id: linkbtnId ? linkbtnId : menuId };
      const exists = (userBtnSession || []).filter(
        (item) => item.id === newItem.id,
      );
      if (exists.length === 0) {
        isSubMenuSecondView.current = false;
        isSubMenuThirdView.current = false;
      } else if (exists.length === 1) {
        isSubMenuSecondView.current = true;
        isSubMenuThirdView.current = false;
      } else {
        isSubMenuSecondView.current = false;
        isSubMenuThirdView.current = true;
      }
      setUserBtnSession((prevItems) => [...prevItems, newItem]);
      setCurrentMenuId(newItem?.id);

      setMenuBackButton(mediaData?.menuBackButton || false);
      setMenuContent(mediaData?.contenttype);
      setExternalweblink(mediaData?.externalweblink);
      setSelectedMainMenuVideoTime(mediaData?.videotime || 0);

      setSelectedMainMenuUploadedUrls((prevUrls) => ({
        ...prevUrls,
        leftTop: {
          fileName: mediaData?.leftTop?.fileName || "",
          fileUrl: mediaData?.leftTop?.fileUrl || "",
          enabled: mediaData?.leftTop?.enabled || false,
          width: mediaData?.leftTop?.width || 0,
          height: mediaData?.leftTop?.height || 0,
          disabledPadding: mediaData?.leftTop?.disabledPadding || false,
          disabledMargin: mediaData?.leftTop?.disabledMargin || false,
        },
        leftBottom: {
          fileName: mediaData?.leftBottom?.fileName || "",
          fileUrl: mediaData?.leftBottom?.fileUrl || "",
          enabled: mediaData?.leftBottom?.enabled || false,
          width: mediaData?.leftBottom?.width || 0,
          height: mediaData?.leftBottom?.height || 0,
        },
        rightTop: {
          fileName: mediaData?.rightTop?.fileName || "",
          fileUrl: mediaData?.rightTop?.fileUrl || "",
          enabled: mediaData?.rightTop?.enabled || false,
          width: mediaData?.rightTop?.width || 0,
          height: mediaData?.rightTop?.height || 0,
        },
        rightBottom: {
          fileName: mediaData?.rightBottom?.fileName || "",
          fileUrl: mediaData?.rightBottom?.fileUrl || "",
          enabled: mediaData?.rightBottom?.enabled || false,
          width: mediaData?.rightBottom?.width || 0,
          height: mediaData?.rightBottom?.height || 0,
        },
        splashVideo: {
          fileName: mediaData?.splashVideo?.fileName || "",
          fileUrl: mediaData?.splashVideo?.fileUrl || "",
          enabled: mediaData?.splashVideo?.enabled || false,
          captionFile: mediaData?.splashVideo?.captionFile || "",
        },
        splashVideotwo: {
          fileName: mediaData?.splashVideotwo?.fileName || "",
          fileUrl: mediaData?.splashVideotwo?.fileUrl || "",
          enabled: mediaData?.splashVideotwo?.enabled || false,
          captionFile: mediaData?.splashVideotwo?.captionFile || "",
        },
        splashVideothree: {
          fileName: mediaData?.splashVideothree?.fileName || "",
          fileUrl: mediaData?.splashVideothree?.fileUrl || "",
          enabled: mediaData?.splashVideothree?.enabled || false,
          captionFile: mediaData?.splashVideothree?.captionFile || "",
        },
        centerLogo: {
          fileName: mediaData?.centerLogoMedia?.fileName || "",
          fileUrl: mediaData?.centerLogoMedia?.fileUrl || "",
          enabled: mediaData?.centerLogoMedia?.enabled || false,
        },
        centerBelowMenuMedia: {
          fileName: mediaData?.centerBelowMenuMedia?.fileName || "",
          fileUrl: mediaData?.centerBelowMenuMedia?.fileUrl || "",
          enabled: mediaData?.centerBelowMenuMedia?.enabled || false,
        },
        backMenuMedia: {
          fileName: mediaData?.backMenuMedia?.fileName || "",
          fileUrl: mediaData?.backMenuMedia?.fileUrl || "",
          enabled: mediaData?.backMenuMedia?.enabled || false,
          width: mediaData?.backMenuMedia?.width || 0,
          height: mediaData?.backMenuMedia?.height || 0,
        },
      }));
      try {
        const response2 = await axios.get(
          `/api/frontendview-main-settings/${linkbtnId ? linkbtnId : menuId}`,
        );
        const mediaData2 = response2.data;

        numColumns.current =
          mediaData2?.finalSettings?.numColumns || "center-two-buttons-per-row";
        columnSpacing.current = mediaData2?.finalSettings?.columnSpacing || 5;
        enableOffset.current = mediaData2?.finalSettings?.enableOffset || false;
        leftOffset.current = mediaData2?.finalSettings?.leftOffset || 5;
        rightOffset.current = mediaData2?.finalSettings?.rightOffset || 0;
        topOffset.current = mediaData2?.finalSettings?.topOffset || 5;
        disableAnimation.current =
          mediaData2?.finalSettings?.disableAnimation || false;

        enableVideoEndOffset.current =
          mediaData2?.finalSettings?.enableVideoEndOffset || false;

        videoEndTopOffset.current =
          mediaData2?.finalSettings?.videoEndTopOffset || 5;

        videoEndLeftOffset.current =
          mediaData2?.finalSettings?.videoEndLeftOffset || 0;

        videoEndRightOffset.current =
          mediaData2?.finalSettings?.videoEndRightOffset || 0;

        // Wheelchair content offset
        wheelchairContentOffsetY.current = mediaData2?.finalSettings?.wheelchairContentOffsetY ?? 20;

        // Use stored Next Navigation settings from submenu parent (always in submenu context here)
        enableNextNavigation.current =
          subMenuNextNavSettings.current.enableNextNavigation;
        nextButtonTopOffset.current =
          subMenuNextNavSettings.current.nextButtonTopOffset;
        nextButtonLeftOffset.current =
          subMenuNextNavSettings.current.nextButtonLeftOffset;
        nextButtonRightOffset.current =
          subMenuNextNavSettings.current.nextButtonRightOffset;
        nextButtonBottomOffset.current =
          subMenuNextNavSettings.current.nextButtonBottomOffset;
        console.log(
          "Using stored submenu Next Navigation settings (back navigation):",
          subMenuNextNavSettings.current,
        );

        setSubMenuSettings((prev) => ({
          ...prev,
          columnSpacing: mediaData2?.finalSettings?.columnSpacing || 5,
          numColumns:
            mediaData2?.finalSettings?.numColumns ||
            "center-two-buttons-per-row",
          enableOffset: mediaData2?.finalSettings?.enableOffset || false,
          leftOffset: mediaData2?.finalSettings?.leftOffset || 5,
          rightOffset: mediaData2?.finalSettings?.rightOffset || 0,
          topOffset: mediaData2?.finalSettings?.topOffset || 5,
          disableAnimation:
            mediaData2?.finalSettings?.disableAnimation || false,
        }));
      } catch (error) {
        console.error(
          "Error fetching main settings:",
          error?.response?.data || error.message,
        );
      }

      if (linkbtnId) {
        const filtersubmenu = (primarySubMenu || []).filter(
          (e) => e.parentId === linkbtnId,
        );
        setSelectedParentMenu(filtersubmenu);
      } else {
        setSelectedParentMenu([]);
      }

      setScreenSteps(3);
      setSubClicked(false);
      setParentMenuId(null);
      setClickedLinkedId(null);
    } catch (error) {
      console.error("Failed to save media data:", error);
    }
  };

  const subhandleTextClick = async (menuId, linkbtnId) => {
    try {
      await axios.post("/api/log/button-click", {
        btnId: menuId,
        client_url,
        language: selectedLanguage,
      });
    } catch (error) {
      console.error("Failed to save media data:", error);
    }

    setParentMenuId(menuId);
    setClickedLinkedId(linkbtnId);
    setPrevParentMenuId(menuId);
    setPrevClickedLinkedId(linkbtnId);
    setSubClicked(true);
  };

  const nonLinkNavigation = async (menuId, linkbtnId) => {
    try {
      numColumns.current = null;
      columnSpacing.current = null;
      enableOffset.current = null;
      leftOffset.current = null;
      rightOffset.current = null;
      topOffset.current = null;
      disableAnimation.current = null;
      isSubMenuSecondView.current = false;
      isSubMenuThirdView.current = false;

      enableVideoEndOffset.current = null;

      videoEndTopOffset.current = null;

      videoEndLeftOffset.current = null;

      videoEndRightOffset.current = null;

      const response = await axios.get(
        `/api/get-btnpage-content/${linkbtnId ? linkbtnId : menuId}/${selectedLanguage}`,
      );
      const mediaData = extractContentFromResponse(response.data);
      const newItem = { id: linkbtnId ? linkbtnId : menuId };
      const exists = (userBtnSession || []).filter(
        (item) => item.id === newItem.id,
      );
      if (exists.length === 0) {
        isSubMenuSecondView.current = false;
        isSubMenuThirdView.current = false;
      } else if (exists.length === 1) {
        isSubMenuSecondView.current = true;
        isSubMenuThirdView.current = false;
      } else {
        isSubMenuSecondView.current = false;
        isSubMenuThirdView.current = true;
      }
      setUserBtnSession((prevItems) => [...prevItems, newItem]);
      setCurrentMenuId(newItem?.id);

      setMenuBackButton(mediaData?.menuBackButton || false);
      setMenuContent(mediaData?.contenttype);
      setSelectedMainMenuVideoTime(mediaData?.videotime || 0);
      setExternalweblink(mediaData?.externalweblink);

      setSelectedMainMenuUploadedUrls((prevUrls) => ({
        ...prevUrls,
        leftTop: {
          fileName: mediaData?.leftTop?.fileName || "",
          fileUrl: mediaData?.leftTop?.fileUrl || "",
          enabled: mediaData?.leftTop?.enabled || false,
          width: mediaData?.leftTop?.width || 0,
          height: mediaData?.leftTop?.height || 0,
          disabledPadding: mediaData?.leftTop?.disabledPadding || false,
          disabledMargin: mediaData?.leftTop?.disabledMargin || false,
        },
        leftBottom: {
          fileName: mediaData?.leftBottom?.fileName || "",
          fileUrl: mediaData?.leftBottom?.fileUrl || "",
          enabled: mediaData?.leftBottom?.enabled || false,
          width: mediaData?.leftBottom?.width || 0,
          height: mediaData?.leftBottom?.height || 0,
        },
        rightTop: {
          fileName: mediaData?.rightTop?.fileName || "",
          fileUrl: mediaData?.rightTop?.fileUrl || "",
          enabled: mediaData?.rightTop?.enabled || false,
          width: mediaData?.rightTop?.width || 0,
          height: mediaData?.rightTop?.height || 0,
        },
        rightBottom: {
          fileName: mediaData?.rightBottom?.fileName || "",
          fileUrl: mediaData?.rightBottom?.fileUrl || "",
          enabled: mediaData?.rightBottom?.enabled || false,
          width: mediaData?.rightBottom?.width || 0,
          height: mediaData?.rightBottom?.height || 0,
        },
        splashVideo: {
          fileName: mediaData?.splashVideo?.fileName || "",
          fileUrl: mediaData?.splashVideo?.fileUrl || "",
          enabled: mediaData?.splashVideo?.enabled || false,
          captionFile: mediaData?.splashVideo?.captionFile || "",
        },
        splashVideotwo: {
          fileName: mediaData?.splashVideotwo?.fileName || "",
          fileUrl: mediaData?.splashVideotwo?.fileUrl || "",
          enabled: mediaData?.splashVideotwo?.enabled || false,
          captionFile: mediaData?.splashVideotwo?.captionFile || "",
        },
        splashVideothree: {
          fileName: mediaData?.splashVideothree?.fileName || "",
          fileUrl: mediaData?.splashVideothree?.fileUrl || "",
          enabled: mediaData?.splashVideothree?.enabled || false,
          captionFile: mediaData?.splashVideothree?.captionFile || "",
        },
        centerLogo: {
          fileName: mediaData?.centerLogoMedia?.fileName || "",
          fileUrl: mediaData?.centerLogoMedia?.fileUrl || "",
          enabled: mediaData?.centerLogoMedia?.enabled || false,
        },
        centerBelowMenuMedia: {
          fileName: mediaData?.centerBelowMenuMedia?.fileName || "",
          fileUrl: mediaData?.centerBelowMenuMedia?.fileUrl || "",
          enabled: mediaData?.centerBelowMenuMedia?.enabled || false,
        },
        backMenuMedia: {
          fileName: mediaData?.backMenuMedia?.fileName || "",
          fileUrl: mediaData?.backMenuMedia?.fileUrl || "",
          enabled: mediaData?.backMenuMedia?.enabled || false,
          width: mediaData?.backMenuMedia?.width || 0,
          height: mediaData?.backMenuMedia?.height || 0,
        },
      }));

      if (linkbtnId) {
        const filtersubmenu = (primarySubMenu || []).filter(
          (e) => e.parentId === linkbtnId,
        );
        setSelectedParentMenu(filtersubmenu);
      } else {
        setSelectedParentMenu([]);
      }
      try {
        const response2 = await axios.get(
          `/api/frontendview-main-settings/${linkbtnId ? linkbtnId : menuId}`,
        );
        const mediaData2 = response2.data;

        numColumns.current =
          mediaData2?.finalSettings?.numColumns || "center-two-buttons-per-row";
        columnSpacing.current = mediaData2?.finalSettings?.columnSpacing || 5;
        enableOffset.current = mediaData2?.finalSettings?.enableOffset || false;
        leftOffset.current = mediaData2?.finalSettings?.leftOffset || 5;
        rightOffset.current = mediaData2?.finalSettings?.rightOffset || 0;
        topOffset.current = mediaData2?.finalSettings?.topOffset || 5;
        disableAnimation.current =
          mediaData2?.finalSettings?.disableAnimation || false;

        enableVideoEndOffset.current =
          mediaData2?.finalSettings?.enableVideoEndOffset || false;

        videoEndTopOffset.current =
          mediaData2?.finalSettings?.videoEndTopOffset || 5;

        videoEndLeftOffset.current =
          mediaData2?.finalSettings?.videoEndLeftOffset || 0;

        videoEndRightOffset.current =
          mediaData2?.finalSettings?.videoEndRightOffset || 0;

        // Wheelchair content offset
        wheelchairContentOffsetY.current = mediaData2?.finalSettings?.wheelchairContentOffsetY ?? 20;

        // Video End Navigation
        enableVideoEndNavigation.current = mediaData2?.finalSettings?.enableVideoEndNavigation ?? false;
        videoEndNavigationMenuId.current = mediaData2?.finalSettings?.videoEndNavigationMenuId ?? null;

        // Use stored Next Navigation settings from submenu parent (if in submenu context)
        if (currentSubMenuParentRef.current) {
          // We're in a submenu, use the stored settings
          enableNextNavigation.current =
            subMenuNextNavSettings.current.enableNextNavigation;
          nextButtonTopOffset.current =
            subMenuNextNavSettings.current.nextButtonTopOffset;
          nextButtonLeftOffset.current =
            subMenuNextNavSettings.current.nextButtonLeftOffset;
          nextButtonRightOffset.current =
            subMenuNextNavSettings.current.nextButtonRightOffset;
          nextButtonBottomOffset.current =
            subMenuNextNavSettings.current.nextButtonBottomOffset;
          console.log(
            "Using stored submenu Next Navigation settings:",
            subMenuNextNavSettings.current,
          );
        } else {
          // Main menu content page - fetch individual settings
          enableNextNavigation.current =
            mediaData2?.finalSettings?.enableNextNavigation || false;
          nextButtonTopOffset.current =
            mediaData2?.finalSettings?.nextButtonTopOffset ?? null;
          nextButtonLeftOffset.current =
            mediaData2?.finalSettings?.nextButtonLeftOffset ?? null;
          nextButtonRightOffset.current =
            mediaData2?.finalSettings?.nextButtonRightOffset ?? null;
          nextButtonBottomOffset.current =
            mediaData2?.finalSettings?.nextButtonBottomOffset ?? null;
        }
      } catch (error) {
        console.error(
          "Error fetching main settings:",
          error?.response?.data || error.message,
        );
      }

      setScreenSteps(3);
      setSubClicked(false);
      setParentMenuId(null);
      setClickedLinkedId(null);
    } catch (error) {
      console.error("Failed to save media data:", error);
    }
  };

  const subBacklick = async (menuId, linkbtnId) => {
    console.log("subBacklick called:", {
      menuId,
      linkbtnId,
      selectedParentMenuLength: selectedParentMenu.length,
      currentUserSteps: userSteps,
    });

    if (selectedParentMenu.length === 0) {
      console.log("No selectedParentMenu - calling nonLinkNavigation");
      setSubClicked(true);
      await nonLinkNavigation(menuId, linkbtnId);

      setParentMenuId(menuId);
      setClickedLinkedId(linkbtnId);
      setPrevParentMenuId(menuId);
      setPrevClickedLinkedId(linkbtnId);
    } else {
      console.log("Has selectedParentMenu - setting animation states");
      setSubClicked(true);
      setParentMenuId(menuId);
      setClickedLinkedId(linkbtnId);
      setPrevParentMenuId(menuId);
      setPrevClickedLinkedId(linkbtnId);
    }
  };

  const handleVideoEnd = () => {
    if (screenSteps === 1) {
      if (splashVideoTime === 0) {
        videoRef.current.play();
      } else if (playCount < splashVideoTime - 1) {
        setPlayCount((prevCount) => prevCount + 1);
        videoRef.current.play();
      } else {
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }

        setFadeOut(true);
        setPlayCount(0);
        setTimeout(() => {
          setScreenSteps(2);
        }, 2000);
      }
    }
  };

  const handleFadeVideoEnd = () => {
    if (screenSteps === 1) {
      if (videoRef.current) {
        videoRef.current.pause();
      }

      setFadeOut(true);
      setPlayCount(0);
      setScreenSteps(2);

      if (videoRef.current) {
        videoRef.current.currentTime = 0;
      }
    }
  };

  const handleTopicTextClick = async () => {
    setTriviaQuiz(true);
    setClicked(true);
  };

  const handleSubTopicTextClick = async () => {
    setTriviaQuiz(true);
    setSubClicked(true);
  };

  const handleQuizTextClick = async (topicId) => {
    await axios
      .get(`/api/topic-settings/${currentUserId}/${topicId}`)
      .then((res) => {
        const response = res.data?.questions;
        const randomPickedQuestion =
          res.data?.randomPickedQuestion?.randomPickedQuestion ?? 0;

        if (response.length > 0) {
          setSelectedTopicId(topicId);
          const shuffledQuestions = response.sort(() => 0.5 - Math.random());
          const selectedQuestions = shuffledQuestions.slice(
            0,
            randomPickedQuestion,
          );
          
          // Transform multilingual questions to extract text for selected language
          const transformedQuestions = selectedQuestions.map((q) => ({
            ...q,
            question: getTextForLanguage(q.question, q.question?.en || "", selectedLanguage),
            options: (q.options || []).map((opt) => 
              getTextForLanguage(opt, opt?.en || "", selectedLanguage)
            ),
            correctAnswer: getTextForLanguage(q.correctAnswer, q.correctAnswer?.en || "", selectedLanguage),
          }));
          
          setQuestions(transformedQuestions);
          setClickedTopic(true);
        } else {
          showErrorToast("Sorry No Questions Exist in Selected Topics");
        }
      });
  };

  const handleQuizAnimationComplete = () => {
    setClickedTopic(false);
    setScreenSteps(5);
    setTriviaQuiz(false);
  };

  const loadingInterval = useRef();

  // useEffect(() => {
  //   if (!videoRef.current || !uploadedUrls?.splashVideo?.fileUrl) return;
  //   const video = videoRef.current;
  //   video.preload = "auto";
  //   video.load();

  //   const checkBufferStatus = () => {
  //     if (
  //       video.buffered.length > 0 &&
  //       (screenSteps === 1 || screenSteps === 0)
  //     ) {
  //       const bufferedEnd = video.buffered.end(video.buffered.length - 1);
  //       const percent = (bufferedEnd / video.duration) * 100;
  //       if (percent >= 99.9) {
  //         clearInterval(loadingInterval.current);
  //       }
  //     }
  //   };

  //   loadingInterval.current = setInterval(checkBufferStatus, 500);

  //   video.addEventListener("canplaythrough", () => {
  //     console.log(
  //       "Native canplaythrough event - video should play without buffering",
  //     );
  //   });

  //   return () => {
  //     clearInterval(loadingInterval.current);
  //     video.removeEventListener("canplaythrough");
  //   };
  // }, [uploadedUrls?.splashVideo?.fileUrl]);

  useEffect(() => {
    if (!videoRef.current || !uploadedUrls?.splashVideo?.fileUrl) return;

    const video = videoRef.current;
    video.preload = "auto";
    video.load();

    const checkBufferStatus = () => {
      if (
        video.buffered.length > 0 &&
        (screenSteps === 1 || screenSteps === 0)
      ) {
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        const percent = (bufferedEnd / video.duration) * 100;

        if (percent >= 99.9) {
          clearInterval(loadingInterval.current);
        }
      }
    };

    loadingInterval.current = setInterval(checkBufferStatus, 500);

    // ✅ Store handler reference
    const handleCanPlayThrough = () => {
      console.log(
        "Native canplaythrough event - video should play without buffering"
      );
    };

    video.addEventListener("canplaythrough", handleCanPlayThrough);

    return () => {
      clearInterval(loadingInterval.current);
      loadingInterval.current = null;
      
      // ✅ Pass SAME function reference and check if video still exists
      if (video) {
        video.removeEventListener("canplaythrough", handleCanPlayThrough);
      }
    };
  }, [uploadedUrls?.splashVideo?.fileUrl, screenSteps]);

  console.log("userSteps", userSteps);

  useEffect(() => {
    if (screenSteps !== 1 && videoRef.current) {
      const video = videoRef.current;
      video.pause();
      video.currentTime = 0;
    }
    if (screenSteps === 1 && videoRef.current) {
      const video = videoRef.current;
      video.play().catch(err => console.error("Video play error:", err));
      // Reset wheelchair mode when returning to splash screen
      resetLocalStates();
    }
    
    // Cleanup video when leaving screen 1
    return () => {
      if (screenSteps !== 1 && videoRef.current) {
        const video = videoRef.current;
        video.pause();
        video.currentTime = 0;
      }
    };
  }, [screenSteps]);

  const handleInitialSteps = () => {
    if (isTimeRange) {
      if (videoRef.current) {
        videoRef.current.play().catch((err) => {
          console.error("Video play failed:", err);
        });
      }

      if (skipAttractLoop) {
        setScreenSteps(2);
      } else setScreenSteps(1);
    }
  };

  const handleAttractLoop = () => {
    if (skipAttractLoop && screenSteps !== 2) {
      setScreenSteps(2);
    } else if (skipAttractLoop && screenSteps === 2) {
      setScreenSteps(0);
      setIsCaptionOn(false);
    } else {
      setScreenSteps(1);
    }
  };

  useEffect(() => {
    if (userId) {
      axios

        .get(`/api/captions/get-caption/${userId}`)

        .then((response) => {
          if (response.status === 404) {
            return;
          }

          if (response.data.status === true) {
            const captionData = response.data;

            // Parse background opacity from existing bgColor

            let backgroundOpacity = 60; // default

            let bgColor = "#000000"; // default

            if (captionData.bgColor) {
              if (captionData.bgColor.startsWith("rgba")) {
                // Extract opacity from rgba

                const matches = captionData.bgColor.match(
                  /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/,
                );

                if (matches && matches[4]) {
                  backgroundOpacity = Math.round(parseFloat(matches[4]) * 100);

                  // Get just the RGB part

                  bgColor = `rgb(${matches[1]}, ${matches[2]}, ${matches[3]})`;
                }
              } else {
                bgColor = captionData.bgColor;
              }
            }

            // Parse text shadow properties

            let textShadowH = "2";

            let textShadowV = "2";

            let textShadowBlur = "4";

            let textShadowColor = "#000000";

            if (captionData.textShadow) {
              const shadowParts = captionData.textShadow.split(" ");

              if (shadowParts.length >= 4) {
                textShadowH = shadowParts[0].replace("px", "");

                textShadowV = shadowParts[1].replace("px", "");

                textShadowBlur = shadowParts[2].replace("px", "");

                textShadowColor = shadowParts.slice(3).join(" ");
              }
            }

            // Parse numeric values from strings

            const parseNumeric = (value, defaultValue) => {
              if (typeof value === "string") {
                const num = parseFloat(value);

                return isNaN(num) ? defaultValue : num.toString();
              }

              return value;
            };

            setCaptionSettings({
              textColor: captionData.textColor || "#ffffff",

              bgColor: bgColor,

              backgroundOpacity: backgroundOpacity,

              fontSize: parseNumeric(captionData.fontSize, "22"),

              padding: parseNumeric(captionData.padding, "8"),

              fontWeight: captionData.fontWeight || "600",

              bottom: parseNumeric(captionData.bottom, "40"),

              // Text shadow properties

              textShadowH: textShadowH,

              textShadowV: textShadowV,

              textShadowBlur: textShadowBlur,

              textShadowColor: textShadowColor,

              lineHeight: captionData.lineHeight || "1.4",

              letterSpacing: parseNumeric(captionData.letterSpacing, "0"),

              fontFamily: captionData.fontFamily || "Arial",

              transition: parseNumeric(captionData.transition, "2"),

              buttonTop: captionData.buttonTop,

              buttonLeft: captionData.buttonLeft,

              iconType: captionData.iconType,

              iconSize: captionData.iconSize,

              iconOnColor: captionData.iconOnColor,

              iconOffColor: captionData.iconOffColor,

              status: captionData.status,
            });
          }
        })
        .catch((error) => {
          console.log("No caption settings found");
        });
    }
  }, [userId]);

  // Fetch weather settings
  useEffect(() => {
    if (userId) {
      fetch(`/api/weather-settings/get/${userId}`)
        .then(r => r.json())
        .then(data => {
          if (data && data.enabled) {
            setWeatherSettings(data);
          }
        })
        .catch(() => { });

      // Fetch wheelchair settings
      fetch(`/api/wheelchair-settings/get/${userId}`)
        .then(r => r.json())
        .then(data => {
          if (data.success && data.data) {
            setWheelchairSettings(data.data);
          }
        })
        .catch(() => { });
    }
  }, [userId]);

  const handleCaptionToggle = () => {
    const newCaptionState = !isCaptionOn;
    setIsCaptionOn(newCaptionState);
    console.log('Caption toggled to:', newCaptionState);
  };

  useEffect(() => {
    splashVideoRef.current = toggleState;
  }, [toggleState]);

  return (
    <div
      className="responsive-video-playerr"
      style={{ cursor: screenSteps === 1 ? "pointer" : "" }}
      onClick={() => (screenSteps === 1 ? handleFadeVideoEnd() : "")}
    >

      {/* Step 0 */}
      {screenSteps === 0 && (
        <div
          className="preload-screen"
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (
              (preventPreloadScreen && videoDownloaded) ||
              !preventPreloadScreen
            ) {
              handleInitialSteps();
            }
          }}
        >
          {uploadedUrls?.closedVideo?.enabled &&
            uploadedUrls?.closedVideo?.fileUrl &&
            !isTimeRange ? (
            <SplashClosedVideoLoop
              videoRef={videoRef}
              videoKey={uploadedUrls?.closedVideo?.fileUrl}
            />
          ) : (
            <div className="preload-logo-container">
              <img
                src={
                  isTimeRange
                    ? uploadedUrls?.splashLogoMedia.fileUrl
                    : uploadedUrls?.closedLogoMedia?.fileUrl ||
                    uploadedUrls?.splashLogoMedia?.fileUrl
                }
                style={{
                  width:
                    uploadedUrls?.splashLogoMedia?.width > 0
                      ? `${uploadedUrls.splashLogoMedia.width}vw`
                      : "100vw",
                }}
                alt="Logo"
                className="preload-logo"
              />
            </div>
          )}
        </div>
      )}

      <div className="videoWrap">
        {/* Menu Catalogue Page */}
        {screenSteps === 2 && numColumns.current && (
          <>
            {isAirtableEnabled && airtableConfig ? (
              <AirtableMenu
                userId={currentUserId}
                airtableConfig={airtableConfig}
                airtableData={airtableData}
                airtableVideosDownloaded={airtableVideosDownloaded}
                brandColor={brandColor}
                globalSettings={menuTextSettings.globalSettings}
                airTablesettings={airTablesettings}
                buttonSettings={buttonSettings}
                onBackToMenu={() => {
                  setFadeOut(false);
                  setPlayCount(0);
                  //setScreenSteps(1)
                  handleAttractLoop();
                  setVideoLoaded(false);
                  setUserSteps(0);
                  setUserStepsArr([]);
                  setUserBtnSession([]);
                  setIsSecondView(0);
                }}
                numColumns={numColumns.current}
                columnSpacing={columnSpacing.current}
                enableOffset={enableOffset.current}
                leftOffset={leftOffset.current}
                topOffset={topOffset.current}
                rightOffset={rightOffset.current}
                lineHeight={lineHeight}
                padding={padding}
                fontSize={fontSize}
                brandFont={brandFont}
                uploadedUrls={menuuploadedUrls}
                splashText={menusplashText}
                videotime={videotime}
                isSecondView={isSecondView === 2 ? true : false}
                isthirdView={isSecondView >= 3 ? true : false}
                resetSession={async () => {
                  setFadeOut(false);
                  setPlayCount(0);
                  // setScreenSteps(1)
                  handleAttractLoop();
                  setVideoLoaded(false);
                  setUserSteps(0);
                  setUserStepsArr([]);
                  setUserBtnSession([]);
                  setIsSecondView(0);
                  resetLocalStates();
                }}
                changeVideoFun={() => setIsSecondView((prev) => prev + 1)}
                removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
                client_url={client_url}
                disableAnimation={disableAnimation.current}
              />
            ) : (
              <MenuCatalouges
                currentState={currentState}
                handleInvisibleToggle={handleInvisibleToggle}
                toggleState={toggleState}
                setToggleState={setToggleState}
                fetchMedia={fetchMedia}
                enableVideoEndOffset={enableVideoEndOffset}
                videoEndTopOffset={videoEndTopOffset}
                videoEndLeftOffset={videoEndLeftOffset}
                videoEndRightOffset={videoEndRightOffset}
                skipAttractLoop={skipAttractLoop}
                toggleSkipAttractLoop={toggleSkipAttractLoop}
                enableAttractLoopSwitchOnMainMenu={
                  enableAttractLoopSwitchOnMainMenu
                }
                disableAreYouTherePopup={disableAreYouTherePopup}
                enableInvisibleToggleButton={enableInvisibleToggleButton}
                menu={frontendMainMenu}
                clicked={clicked}
                handleTextClick={handleTextClick}
                uploadedUrls={menuuploadedUrls}
                handleFinalAction={handleAnimationComplete}
                splashText={menusplashText}
                settings={menuTextSettings}
                videotime={videotime}
                subMenuSettings={subMenuSettings}
                numColumns={numColumns.current}
                columnSpacing={columnSpacing.current}
                enableOffset={enableOffset.current}
                leftOffset={leftOffset.current}
                topOffset={topOffset.current}
                backToMenu={() => {
                  setFadeOut(false);
                  setPlayCount(0);
                  //setScreenSteps(1)
                  handleAttractLoop();
                  setVideoLoaded(false);
                  setUserSteps(0);
                  setUserStepsArr([]);
                  setUserBtnSession([]);
                  setIsSecondView(0);

                  if (currentState) {
                    splashVideoRef.current = true;
                    console.log(
                      "Splash video ref set to true on back to menu with toggle key",
                      splashVideoRef,
                    );
                  }
                }}
                isSecondView={isSecondView === 2 ? true : false}
                isthirdView={isSecondView >= 3 ? true : false}
                brandColor={brandColor}
                resetSession={async () => {
                  setFadeOut(false);
                  setPlayCount(0);
                  //setScreenSteps(1)
                  handleAttractLoop();
                  setVideoLoaded(false);
                  setUserSteps(0);
                  setUserStepsArr([]);
                  setUserBtnSession([]);
                  setIsSecondView(0);
                  setIsCaptionOn(false);
                  resetLocalStates();

                }}
                changeVideoFun={() => setIsSecondView((prev) => prev + 1)}
                handleTopicTextClick={handleTopicTextClick}
                brandFont={brandFont}
                rightOffset={rightOffset.current}
                lineHeight={lineHeight}
                padding={padding}
                fontSize={fontSize}
                removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
                disableAnimation={disableAnimation.current}
                menuPopup={menuPopup}
                captionSettings={captionSettings}
                setIsCaptionOn={setIsCaptionOn}
                isCaptionOn={isCaptionOn}
                handleWayfinderButtonClick={handleWayfinderNavigation}
                popupDisable={popupDisable}
                clientUrl={client_url}
                onSplashVideoUpdate={(updatedVideos) => {
                  setUploadedUrls((prevUrls) => ({
                    ...prevUrls,
                    splashVideo: updatedVideos.splashVideo,
                    splashVideoTwo: updatedVideos.splashVideoTwo,
                  }));
                }}
                selectedLanguage={selectedLanguage}
                availableLanguages={availableLanguages}
                onLanguageChange={handleLanguageSelect}
                getLanguageName={getLanguageName}
                getLanguageFlag={getLanguageFlag}
                languageOffsets={languageOffsets}
                languageCustomization={languageCustomization}
                languageIcons={languageIcons}
                languageIconSizes={languageIconSizes}
                languageDisplayNames={languageDisplayNames}
                isLanguageLoading={isLanguageLoading}

                enableVideoEndNavigation={enableVideoEndNavigation}
                videoEndNavigationMenuId={videoEndNavigationMenuId}

                primaryMenu={primaryMenu}
                primarySubMenu={primarySubMenu}
                subhandleTextClick={subhandleTextClick}
                weatherSettings={weatherSettings}
                wheelchairSettings={wheelchairSettings}
                wheelchairContentOffsetY={wheelchairContentOffsetY.current}
                isWheelchairMode={isWheelchairMode}
                onWheelchairToggle={handleWheelchairToggle}
              />
            )}
          </>
        )}


        {/* Submenu */}
        {screenSteps === 3 && numColumns.current && (
          <SubMenuPage
            enableInvisibleToggleButton={enableInvisibleToggleButton}
            enableVideoEndOffset={enableVideoEndOffset}
            videoEndTopOffset={videoEndTopOffset}
            videoEndLeftOffset={videoEndLeftOffset}
            videoEndRightOffset={videoEndRightOffset}
            menu={selectedParentMenu || []}
            clicked={subclicked}
            handleTextClick={(menuId, linkbtnId) => {
              subhandleTextClick(menuId, linkbtnId);

              // Use functional update to get the latest userSteps value
              setUserSteps((prevUserSteps) => {
                const nextUserStep = prevUserSteps + 1;

                const newItem = {
                  userSteps: nextUserStep,
                  menuId: menuId,
                  linkbtnId: linkbtnId,
                };

                setUserStepsArr((prevSteps) => {
                  const exists = prevSteps.some(
                    (step) =>
                      step.userSteps === newItem.userSteps &&
                      step.menuId === newItem.menuId &&
                      step.linkbtnId === newItem.linkbtnId,
                  );
                  if (exists) return prevSteps;
                  return [...prevSteps, newItem];
                });

                console.log("USer steps", userStepsArr);

                return nextUserStep;
              });
            }}
            uploadedUrls={selectedMainMenuUploadedUrls}
            handleFinalAction={subhandleAnimationComplete}
            splashText={selectedMainMenuSplashText}
            settings={selectedMainMenuTextSettings}
            backToMenu={async () => {
              // Special case: On content page (video/weblink) with no submenu buttons

              if (
                currentState === false &&
                enableInvisibleToggleButton &&
                enableNextNavigation.current
              ) {

                if (
                  (menuContent === "video" || menuContent === "weblink") &&
                  (!selectedParentMenu || selectedParentMenu.length === 0)
                ) {
                  console.log(
                    "On content page, checking for previous content page",
                  );

                  // Check if we're in a submenu with Next Navigation enabled
                  if (currentSubMenuParentRef.current) {
                    const currentParentId = currentSubMenuParentRef.current;

                    // Get all content pages for this parent
                    const allSubMenuItems = [...(primarySubMenu || [])]
                      .filter((e) => e.parentId === currentParentId)
                      .sort((a, b) => a.order - b.order);
                    const contentPages = allSubMenuItems.filter((item) =>
                      isContentPage(item),
                    );

                    // If there's a previous content page, navigate to it
                    if (currentSubMenuContentIndex > 0) {
                      const prevIndex = currentSubMenuContentIndex - 1;
                      const prevItem = contentPages[prevIndex];

                      setCurrentSubMenuContentIndex(prevIndex);

                      // Decrement userSteps
                      setUserSteps((prevUserSteps) => prevUserSteps - 1);
                      setUserStepsArr((prevSteps) => prevSteps.slice(0, -1));

                      // Load the previous content page
                      try {
                        const response = await axios.get(
                          `/api/get-btnpage-content/${prevItem.linkbtnId ? prevItem.linkbtnId : prevItem.id}/${selectedLanguage}`,
                        );
                        const mediaData = extractContentFromResponse(
                          response.data,
                        );

                        setMenuContent(mediaData?.contenttype);
                        setExternalweblink(mediaData?.externalweblink);
                        setSelectedMainMenuVideoTime(mediaData?.videotime || 0);

                        setSelectedMainMenuUploadedUrls((prevUrls) => ({
                          ...prevUrls,
                          leftTop: {
                            fileName: mediaData?.leftTop?.fileName || "",
                            fileUrl: mediaData?.leftTop?.fileUrl || "",
                            enabled: mediaData?.leftTop?.enabled || false,
                            width: mediaData?.leftTop?.width || 0,
                            height: mediaData?.leftTop?.height || 0,
                            disabledPadding:
                              mediaData?.leftTop?.disabledPadding || false,
                            disabledMargin:
                              mediaData?.leftTop?.disabledMargin || false,
                          },
                          leftBottom: {
                            fileName: mediaData?.leftBottom?.fileName || "",
                            fileUrl: mediaData?.leftBottom?.fileUrl || "",
                            enabled: mediaData?.leftBottom?.enabled || false,
                            width: mediaData?.leftBottom?.width || 0,
                            height: mediaData?.leftBottom?.height || 0,
                          },
                          rightTop: {
                            fileName: mediaData?.rightTop?.fileName || "",
                            fileUrl: mediaData?.rightTop?.fileUrl || "",
                            enabled: mediaData?.rightTop?.enabled || false,
                            width: mediaData?.rightTop?.width || 0,
                            height: mediaData?.rightTop?.height || 0,
                          },
                          rightBottom: {
                            fileName: mediaData?.rightBottom?.fileName || "",
                            fileUrl: mediaData?.rightBottom?.fileUrl || "",
                            enabled: mediaData?.rightBottom?.enabled || false,
                            width: mediaData?.rightBottom?.width || 0,
                            height: mediaData?.rightBottom?.height || 0,
                          },
                          splashVideo: {
                            fileName: mediaData?.splashVideo?.fileName || "",
                            fileUrl: mediaData?.splashVideo?.fileUrl || "",
                            enabled: mediaData?.splashVideo?.enabled || false,
                            captionFile:
                              mediaData?.splashVideo?.captionFile || "",
                          },
                          splashVideotwo: {
                            fileName: mediaData?.splashVideotwo?.fileName || "",
                            fileUrl: mediaData?.splashVideotwo?.fileUrl || "",
                            enabled: mediaData?.splashVideotwo?.enabled || false,
                            captionFile:
                              mediaData?.splashVideotwo?.captionFile || "",
                          },
                          splashVideothree: {
                            fileName: mediaData?.splashVideothree?.fileName || "",
                            fileUrl: mediaData?.splashVideothree?.fileUrl || "",
                            enabled:
                              mediaData?.splashVideothree?.enabled || false,
                            captionFile:
                              mediaData?.splashVideothree?.captionFile || "",
                          },
                          centerLogo: {
                            fileName: mediaData?.centerLogoMedia?.fileName || "",
                            fileUrl: mediaData?.centerLogoMedia?.fileUrl || "",
                            enabled: mediaData?.centerLogoMedia?.enabled || false,
                            width: mediaData?.centerLogoMedia?.width || 0,
                            height: mediaData?.centerLogoMedia?.height || 0,
                          },
                          centerBelowMenuMedia: {
                            fileName:
                              mediaData?.centerBelowMenuMedia?.fileName || "",
                            fileUrl:
                              mediaData?.centerBelowMenuMedia?.fileUrl || "",
                            enabled:
                              mediaData?.centerBelowMenuMedia?.enabled || false,
                            width: mediaData?.centerBelowMenuMedia?.width || 0,
                            height: mediaData?.centerBelowMenuMedia?.height || 0,
                          },
                          backMenuMedia: {
                            fileName: mediaData?.backMenuMedia?.fileName || "",
                            fileUrl: mediaData?.backMenuMedia?.fileUrl || "",
                            enabled: mediaData?.backMenuMedia?.enabled || false,
                            width: mediaData?.backMenuMedia?.width || 0,
                            height: mediaData?.backMenuMedia?.height || 0,
                          },
                        }));

                        setSelectedMainMenuSplashText(
                          getTextForLanguage(
                            mediaData?.splashText,
                            mediaData?.splashText ?? "",
                          ),
                        );
                        setSelectedMainMenuTextSettings((prevSettings) => ({
                          ...prevSettings,
                          globalSettings: {
                            ...prevSettings?.globalSettings,
                            ...mediaData?.globalSettings,
                          },
                        }));

                        setSelectedParentMenu([]);
                        setScreenSteps(3);

                        return;
                      } catch (err) {
                        console.error(
                          "Error loading previous content page:",
                          err,
                        );
                      }
                    } else {
                      // At first content page (index 0), go back to parent submenu
                      console.log(
                        "At first content page, going back to parent submenu",
                      );

                      // Find the parent submenu step in userStepsArr
                      const parentStep = (userStepsArr || []).find(
                        (e) => e.linkbtnId === currentParentId,
                      );

                      if (parentStep) {
                        // Reset to parent submenu step
                        setUserSteps(parentStep.userSteps);
                        // Keep only steps up to and including the parent step
                        setUserStepsArr((prevSteps) =>
                          prevSteps.filter(
                            (step) => step.userSteps <= parentStep.userSteps,
                          ),
                        );

                        // Reset content tracking
                        setCurrentSubMenuContentIndex(-1);
                        currentSubMenuParentRef.current = null;

                        // Load the parent submenu with buttons
                        await subBackhandleAnimationComplete(
                          parentStep.menuId,
                          parentStep.linkbtnId,
                        );
                        return;
                      } else {
                        // If no parent step found, try to find it by checking userStepsArr for the parent

                        // The parent should be at userSteps - 1 or the last step in the array
                        const lastStep = userStepsArr[userStepsArr.length - 1];

                        if (lastStep && lastStep.linkbtnId === currentParentId) {
                          setUserSteps(lastStep.userSteps);
                          setUserStepsArr((prevSteps) =>
                            prevSteps.filter(
                              (step) => step.userSteps <= lastStep.userSteps,
                            ),
                          );
                          setCurrentSubMenuContentIndex(-1);
                          currentSubMenuParentRef.current = null;
                          await subBackhandleAnimationComplete(
                            lastStep.menuId,
                            lastStep.linkbtnId,
                          );
                          return;
                        }

                        setCurrentSubMenuContentIndex(-1);
                        const preservedParentId = currentParentId;
                        currentSubMenuParentRef.current = null;

                        // Find what userStep the parent should be at
                        const parentInHistory = (userStepsArr || []).find(
                          (e) =>
                            e.menuId === preservedParentId ||
                            e.linkbtnId === preservedParentId,
                        );

                        if (parentInHistory) {
                          setUserSteps(parentInHistory.userSteps);
                          setUserStepsArr((prevSteps) =>
                            prevSteps.filter(
                              (step) =>
                                step.userSteps <= parentInHistory.userSteps,
                            ),
                          );
                        } else {
                          // Assume it's at step 1 (first submenu level)
                          setUserSteps(1);
                          setUserStepsArr((prevSteps) => prevSteps.slice(0, 1));
                        }

                        await subBackhandleAnimationComplete(
                          preservedParentId,
                          preservedParentId,
                        );
                        return;
                      }
                    }
                  }

                  // Fallback: go to main menu
                  // console.log("No previous content page or parent, going to main menu");
                  // setScreenSteps(2);
                  // setUserSteps(0);
                  // setUserStepsArr([]);
                  // setUserBtnSession([]);
                  // setSelectedParentMenu([]);
                  // currentSubMenuParentRef.current = null;
                  // setCurrentSubMenuContentIndex(-1);
                  // setCurrentMainMenuContentIndex(-1);
                  // enableNextNavigation.current = false;
                  // setIsSecondView((prev) => prev + 1);
                  // await fetchMedia(client_url);
                  // return;

                  const filterData = (userStepsArr || []).find(
                    (e) => e.userSteps === userSteps - 1,
                  );
                  if (filterData) {
                    subBacklick(filterData?.menuId, filterData?.linkbtnId);
                  } else {
                    setIsSecondView((prev) => prev + 1);
                    await fetchMedia(client_url);
                    setScreenSteps(2);
                  }
                  setUserStepsArr((prevSteps) => prevSteps.slice(0, -1));
                  setUserSteps((prev) => (prev > 0 ? prev - 1 : 0));
                }

                // For submenu pages with buttons: navigate back through history
                const previousStep = userSteps - 1;

                const filterData = (userStepsArr || []).find(
                  (e) => e.userSteps === previousStep,
                );

                if (filterData) {
                  // Update state before navigation
                  setUserSteps(previousStep);
                  setUserStepsArr((prevSteps) => prevSteps.slice(0, -1));

                  // Check if we're going back to main menu (userSteps will be 0)
                  if (previousStep === 0) {
                    setScreenSteps(2);
                    setUserSteps(0);
                    setUserStepsArr([]);
                    setUserBtnSession([]);
                    setSelectedParentMenu([]);
                    currentSubMenuParentRef.current = null;
                    setCurrentSubMenuContentIndex(-1);
                    setCurrentMainMenuContentIndex(-1);
                    enableNextNavigation.current = false;
                    setIsSecondView((prev) => prev + 1);
                    await fetchMedia(client_url);
                  } else {
                    // Navigate back using subBacklick

                    await subBacklick(filterData?.menuId, filterData?.linkbtnId);
                  }
                }
              } else {
                // No previous step found - go to main menu

                // setScreenSteps(2);
                // setUserSteps(0);
                // setUserStepsArr([]);
                // setUserBtnSession([]);
                // setSelectedParentMenu([]);
                // currentSubMenuParentRef.current = null;
                // setCurrentSubMenuContentIndex(-1);
                // setCurrentMainMenuContentIndex(-1);
                // enableNextNavigation.current = false;
                // setIsSecondView((prev) => prev + 1);
                // await fetchMedia(client_url);

                const filterData = (userStepsArr || []).find(
                  (e) => e.userSteps === userSteps - 1,
                );
                if (filterData) {
                  subBacklick(filterData?.menuId, filterData?.linkbtnId);
                } else {
                  setIsSecondView((prev) => prev + 1);
                  await fetchMedia(client_url);
                  setScreenSteps(2);
                }
                setUserStepsArr((prevSteps) => prevSteps.slice(0, -1));
                setUserSteps((prev) => (prev > 0 ? prev - 1 : 0));
              }

            }}
            videotime={selectedMainMenuVideoTime}
            menuContent={menuContent}
            externalweblink={externalweblink}
            subMenuSettings={subMenuSettings}
            numColumns={numColumns.current}
            columnSpacing={columnSpacing.current}
            enableOffset={enableOffset.current}
            leftOffset={leftOffset.current}
            topOffset={topOffset.current}
            isSecondView={isSubMenuSecondView.current}
            isthirdView={isSubMenuThirdView.current}
            brandColor={brandColor}
            resetSession={async () => {
              await fetchMedia(client_url);
              resetLocalStates();
              setFadeOut(false);
              setPlayCount(0);
              //setScreenSteps(1)
              handleAttractLoop();
              setVideoLoaded(false);
              setUserSteps(0);
              setUserStepsArr([]);
              setUserBtnSession([]);
              setIsSecondView(0);
              setCurrentMenuId(null);
              setIsCaptionOn(false);
            }}
            changeVideoFun={() => {
              const newItem = { id: currentMenuId };
              const exists = (userBtnSession || []).filter(
                (item) => item.id === newItem.id,
              );
              if (exists.length === 0) {
                isSubMenuSecondView.current = false;
                isSubMenuThirdView.current = false;
              } else if (exists.length === 1) {
                isSubMenuSecondView.current = true;
                isSubMenuThirdView.current = false;
              } else {
                isSubMenuSecondView.current = false;
                isSubMenuThirdView.current = true;
              }
              setUserBtnSession((prevItems) => [...prevItems, newItem]);
            }}
            handleSubTopicTextClick={handleSubTopicTextClick}
            brandFont={brandFont}
            rightOffset={rightOffset.current}
            lineHeight={lineHeight}
            padding={padding}
            fontSize={fontSize}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            disableAnimation={disableAnimation.current}
            menuPopup={menuPopup}
            redirectAttactLoop={redirectAttactLoop}
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}
            handleWayfinderButtonClick={handleWayfinderNavigation}
            disableAreYouTherePopup={disableAreYouTherePopup}
            enableNextNavigation={enableNextNavigation.current}
            nextButtonTopOffset={nextButtonTopOffset.current}
            nextButtonLeftOffset={nextButtonLeftOffset.current}
            nextButtonRightOffset={nextButtonRightOffset.current}
            nextButtonBottomOffset={nextButtonBottomOffset.current}
            currentContentIndex={
              currentSubMenuParentRef.current !== null
                ? currentSubMenuContentIndex
                : currentMainMenuContentIndex
            }
            setCurrentContentIndex={setCurrentSubMenuContentIndex}
            handleNextNavigation={async () => {
              if (currentSubMenuParentRef.current) {
                await handleSubMenuNextNavigation();
              }
              //  else {
              //   await handleMainMenuNextNavigation();
              // }
            }}
            handlePreviousNavigation={async () => {
              if (currentSubMenuParentRef.current) {
                await handleSubMenuPreviousNavigation();
              } else {
                await handleMainMenuPreviousNavigation();
              }
            }}
            globalSettings={globalSettings}
            nextButtonFileUrl={
              globalSettings?.nextButtonFileUrl ||
              selectedMainMenuTextSettings?.globalSettings?.nextButtonFileUrl
            }
            selectedLanguage={selectedLanguage}
            availableLanguages={availableLanguages}
            onLanguageChange={handleLanguageSelect}
            getLanguageName={getLanguageName}
            getLanguageFlag={getLanguageFlag}
            wheelchairSettings={wheelchairSettings}
            wheelchairContentOffsetY={wheelchairContentOffsetY.current}
            clientUrl={client_url}
            weatherSettings={weatherSettings}
            isWheelchairMode={isWheelchairMode}
            onWheelchairToggle={handleWheelchairToggle}
            enableVideoEndNavigation={enableVideoEndNavigation}
            videoEndNavigationMenuId={videoEndNavigationMenuId}
            primaryMenu={primaryMenu}
            primarySubMenu={primarySubMenu}
            subhandleTextClick={subhandleTextClick}

            subMenuVideoEndNavigation={subMenuVideoEndNavigation}
          />
        )}

        {(screenSteps === 4 || screenSteps === 5) && (
          <TrivaMainTopics
            menu={triviaQuizTopics}
            settings={triviaQuizSettings}
            clicked={clickedTopic}
            handleQuizTextClick={handleQuizTextClick}
            handleQuizAnimationComplete={handleQuizAnimationComplete}
            topicquestions={questions || []}
            triviaQuizSettings={triviaQuizSettings}
            brandColor={brandColor}
            screenSteps={screenSteps}
            backToMenu={async () => {
              setTriviaQuiz(false);
              const filterData = (userStepsArr || []).find(
                (e) => e.userSteps === userSteps,
              );
              if (filterData) {
                await subBackhandleAnimationComplete(
                  filterData?.menuId,
                  filterData?.linkbtnId,
                );
              } else {
                if (screenSteps === 4) {
                  setIsSecondView((prev) => prev + 1);
                  await fetchMedia(client_url);
                  setScreenSteps(2);
                } else {
                  setScreenSteps(4);
                }
              }
            }}
            resetSession={async () => {


              await fetchMedia(client_url);
              resetLocalStates();
              setTriviaQuiz(false);
              setFadeOut(false);
              setPlayCount(0);
              //setScreenSteps(1)
              handleAttractLoop();
              setVideoLoaded(false);
              setUserSteps(0);
              setUserStepsArr([]);
              setUserBtnSession([]);
              setIsSecondView(0);
              setCurrentMenuId(null);
            }}
            brandFont={brandFont}
            selectedTopicId={selectedTopicId}
            currentUserId={currentUserId}
          />
        )}

        {/* <div className="video-aspect-ratio"> */}

        {screenSteps === 1 && (
          <VideoPlayerMenu
            videoRef={videoRef}
            videoKey={
              toggleState
                ? uploadedUrls?.splashVideoTwo?.enabled &&
                  uploadedUrls?.splashVideoTwo?.fileUrl
                  ? `${uploadedUrls.splashVideoTwo.fileUrl}_${selectedLanguage}`
                  : uploadedUrls?.splashVideo?.fileUrl
                    ? `${uploadedUrls.splashVideo.fileUrl}_${selectedLanguage}`
                    : ''
                : uploadedUrls?.splashVideo?.enabled &&
                  uploadedUrls?.splashVideo?.fileUrl
                  ? `${uploadedUrls.splashVideo.fileUrl}_${selectedLanguage}`
                  : uploadedUrls?.splashVideoTwo?.fileUrl
                    ? `${uploadedUrls.splashVideoTwo.fileUrl}_${selectedLanguage}`
                    : ''
            }
            handleVideoPlayPage={handleVideoPlay}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={false}
            captionFileUrl={
              toggleState
                ? uploadedUrls?.splashVideoTwo?.enabled &&
                  uploadedUrls?.splashVideoTwo?.captionFile
                  ? uploadedUrls?.splashVideoTwo?.captionFile
                  : uploadedUrls?.splashVideo?.captionFile
                : uploadedUrls?.splashVideo?.enabled &&
                  uploadedUrls?.splashVideo?.captionFile
                  ? uploadedUrls?.splashVideo?.captionFile
                  : uploadedUrls?.splashVideoTwo?.captionFile
            }
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}

          />
        )}

        {/* </div> */}

        {/* Splash Text */}
        {/* Splash Text Overlay */}

        {screenSteps === 1 && (
          <>
            <motion.div
              className="video-container"
              initial={{ opacity: 1 }}
              animate={{ opacity: fadeOut ? 0 : 1 }}
              transition={{ duration: 1 }}
            >
              <div
                className="splashtext-wrapper"
                style={{
                  display: screenSteps === 1 ? "flex" : "none",
                  position: "fixed",
                  top: `${heightoffset}%`,
                  ...(leftoffsetsplash > 0
                    ? { left: `${leftoffsetsplash}%` }
                    : {}),
                  transform: "translateX(-50%)",
                  zIndex: 1,
                  width: "100%",
                  maxWidth: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SplashText
                  text={
                    videoDownloaded
                      ? splashText
                      : splashTextDownload || splashText
                  }
                  settings={settings?.globalSettings}
                />
              </div>
            </motion.div>

            <motion.div
              className="corner-item top-left"
              initial={{ opacity: 1 }}
              animate={{ opacity: fadeOut ? 0 : 1 }}
              transition={{ duration: 1 }}
            >
              {uploadedUrls?.leftTop?.enabled && screenSteps === 1 && (
                <img
                  src={uploadedUrls?.leftTop?.fileUrl || "/placeholder.svg"}
                  alt="Logo"
                  style={{
                    maxWidth: "25vw",
                    maxHeight: "25vw",
                    width: "auto",
                    height: "auto",
                  }}
                // className="corner-image top-left"
                />
              )}
            </motion.div>

            <motion.div
              className="corner-item top-right"
              initial={{ opacity: 1 }}
              animate={{ opacity: fadeOut ? 0 : 1 }}
              transition={{ duration: 1 }}
            >
              {uploadedUrls?.rightTop?.enabled && screenSteps === 1 && (
                <img
                  src={uploadedUrls?.rightTop?.fileUrl || "/placeholder.svg"}
                  alt="Logo"
                  // className="corner-image top-right"
                  style={{
                    maxWidth: "25vw",
                    maxHeight: "25vw",
                    width: "auto",
                    height: "auto",
                  }}
                />
              )}
            </motion.div>

            <motion.div
              className="corner-item bottom-right"
              initial={{ opacity: 1 }}
              animate={{ opacity: fadeOut ? 0 : 1 }}
              transition={{ duration: 1 }}
            >
              {uploadedUrls?.rightBottom?.enabled && screenSteps === 1 && (
                <img
                  src={uploadedUrls?.rightBottom?.fileUrl || "/placeholder.svg"}
                  alt="Logo"
                  // className="corner-image bottom-right"
                  style={{
                    maxWidth: "25vw",
                    maxHeight: "25vw",
                    width: "auto",
                    height: "auto",
                  }}
                />
              )}
            </motion.div>

            <motion.div
              className="corner-item bottom-left"
              initial={{ opacity: 1 }}
              animate={{ opacity: fadeOut ? 0 : 1 }}
              transition={{ duration: 1 }}
            >
              {uploadedUrls?.leftBottom?.enabled && screenSteps === 1 && (
                <img
                  src={uploadedUrls?.leftBottom?.fileUrl || "/placeholder.svg"}
                  alt="Logo"
                  // className="corner-image bottom-left"
                  style={{
                    maxWidth: "25vw",
                    maxHeight: "25vw",
                    width: "auto",
                    height: "auto",
                  }}
                />
              )}
            </motion.div>

            {/* Weather Widget on Splash Screen */}
            {weatherSettings?.enabled && weatherSettings?.visibility?.splashScreen && (
              <motion.div
                initial={{ opacity: 1 }}
                animate={{ opacity: fadeOut ? 0 : 1 }}
                transition={{ duration: 1 }}
                style={{
                  position: 'fixed',
                  zIndex: 10,
                  ...(weatherSettings.horizontalAlign === 'center'
                    ? {
                      left: '50%',
                      transform: 'translateX(-50%)',
                      ...(weatherSettings.positionTop !== null && { top: `${weatherSettings.positionTop}%` }),
                      ...(weatherSettings.positionBottom !== null && { bottom: `${weatherSettings.positionBottom}%` }),
                    }
                    : {
                      ...(weatherSettings.positionLeft !== null && { left: `${weatherSettings.positionLeft}%` }),
                      ...(weatherSettings.positionRight !== null && { right: `${weatherSettings.positionRight}%` }),
                      ...(weatherSettings.positionTop !== null && { top: `${weatherSettings.positionTop}%` }),
                      ...(weatherSettings.positionBottom !== null && { bottom: `${weatherSettings.positionBottom}%` }),
                    }),
                }}
              >
                <WeatherWidget
                  apiKey={weatherSettings.weatherApiKey}
                  latitude={weatherSettings.latitude}
                  longitude={weatherSettings.longitude}
                  forecastDays={weatherSettings.forecastDays}
                  temperatureUnit={weatherSettings.temperatureUnit}
                  celsiusFirst={weatherSettings.celsiusFirst}
                  showLocation={weatherSettings.showLocation}
                  showClock={weatherSettings.showClock}
                  showCurrentWeather={weatherSettings.showCurrentWeather}
                  showForecast={weatherSettings.showForecast}
                  widgetOrder={weatherSettings.widgetOrder}
                  backgroundColor={weatherSettings.backgroundColor}
                  backgroundOpacity={weatherSettings.backgroundOpacity}
                  textColor={weatherSettings.textColor}
                  subTextColor={weatherSettings.subTextColor}
                  padding={weatherSettings.padding}
                  borderRadius={weatherSettings.borderRadius}
                  width={weatherSettings.width}
                  fontFamily={weatherSettings.fontFamily === 'inherit' ? brandFont || 'inherit' : weatherSettings.fontFamily}
                  fontSize={weatherSettings.fontSize}
                  iconSize={weatherSettings.iconSize}
                  forecastIconSize={weatherSettings.forecastIconSize}
                  shadowH={weatherSettings.shadowH}
                  shadowV={weatherSettings.shadowV}
                  shadowBlur={weatherSettings.shadowBlur}
                  shadowSpread={weatherSettings.shadowSpread}
                  shadowColor={weatherSettings.shadowColor}
                  shadowOpacity={weatherSettings.shadowOpacity}
                  useVwSizing={true}
                />
              </motion.div>
            )}
          </>
        )}

        {screenSteps === 0 && (isTimeRange || hasFetchedMediaRef.current) && !disableLocalVideoDownload && (
          
          <CircularDownloadProgress
            videoList={videoList || []}
            airtableVideoList={airtableVideoList || []}
            brandColor={brandColor}
            videoDownloaded={(flag) => {
              console.log("videoDownloaded flag:", flag);
              // if (preventPreloadScreen && flag) {
              //   handleInitialSteps();
              // }
              if (flag) {
                handleInitialSteps();
              }

              setVideoDownloaded(flag);
            }}
          />
        )}

        {/* Wayfinder Search Screen */}
        {screenSteps === 9 && showWayfinderSearch && (
          <>
            <WayfinderSearchScreenFixed
              userId={currentUserId}
              buttonId={currentWayfinderButtonId}
              client_url={client_url}
              brandColor={brandColor}
              brandFont={brandFont}
              onBack={handleWayfinderBack}
              searchSettings={wayfinderSearchSettings}
              searchData={wayfinderSearchData}
              onItemSelect={handleWayfinderItemSelect}
              linkedWayfinder={null}
              backButton={wayfinderBackButton}
              searchType="location"
              navigationHistory={wayfinderNavigationHistory}
              currentLevel="location"
              timeoutPopupSettings={wayfinderSearchSettings?.timeoutPopup}
              categoryIds={
                currentWayfinderConfig?.linkedCategories?.status
                  ? currentWayfinderConfig.linkedCategories.categories
                  : []
              }
              subCategoryIds={
                currentWayfinderConfig?.linkedSubCategories?.status
                  ? currentWayfinderConfig.linkedSubCategories.subcategories
                  : []
              }
              resetSession={async () => {
                setFadeOut(false);
                setPlayCount(0);
                handleAttractLoop();
                setVideoLoaded(false);
                setUserSteps(0);
                setUserStepsArr([]);
                setUserBtnSession([]);
                setIsSecondView(0);
                setIsCaptionOn(false);
                resetLocalStates();
              }}
              selectedLanguage={selectedLanguage}
              wheelchairSettings={wheelchairSettings}
              weatherSettings={weatherSettings}
              isWheelchairMode={isWheelchairMode}
              onWheelchairToggle={handleWheelchairToggle}
              wayfinderGlobalSoundSettings={wayfinderGlobalSoundSettings}
            />
          </>
        )}

        {/* Wayfinder Avatar Screen */}
        {screenSteps === 10 && showWayfinderAvatar && wayfinderLocationData && (
          <>
            <AvatarScreen
              userId={currentUserId}
              client_url={client_url}
              brandColor={brandColor}
              brandFont={brandFont}
              onBack={handleWayfinderBack}
              locationData={wayfinderLocationData}
              backButtonSettings={wayfinderBackButton}
              timeoutPopupSettings={wayfinderSearchSettings?.timeoutPopup}
              replayPopupSettings={wayfinderReplayPopupSettings}

              logoBeforeMap={logoBeforeMap}
              qrCodeSettings={wayfinderQRCodeSettings}
              mapPositionSettings={wayfinderMapPositionSettings}
              language={selectedLanguage}
              captionSettings={captionSettings}
              isCaptionOn={isCaptionOn}
              setIsCaptionOn={setIsCaptionOn}
              cameFromSearch={wayfinderMode === 'categories' || wayfinderMode === 'searchPage'}
              resetSession={async () => {
                setFadeOut(false);
                setPlayCount(0);
                handleAttractLoop();
                setVideoLoaded(false);
                setUserSteps(0);
                setUserStepsArr([]);
                setUserBtnSession([]);
                setIsSecondView(0);
                setIsCaptionOn(false);
                resetLocalStates();
              }}

              selectedLanguage={selectedLanguage}
              weatherSettings={weatherSettings}

              qrCodeConfig={wayfinderQRCodeConfig}
            />
          </>
        )}
      </div>

    </div>

  );
}